"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/landing-page-buy-box/buy-box-store.js":
/*!*************************************************************!*\
  !*** ./js/components/landing-page-buy-box/buy-box-store.js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   planSelectionPending: () => (/* binding */ planSelectionPending),
/* harmony export */   selectedSellingPlanId: () => (/* binding */ selectedSellingPlanId),
/* harmony export */   selectedSellingPlanStore: () => (/* binding */ selectedSellingPlanStore),
/* harmony export */   selectedVariant: () => (/* binding */ selectedVariant),
/* harmony export */   updateSelectedVariant: () => (/* binding */ updateSelectedVariant)
/* harmony export */ });
/* harmony import */ var svelte_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/store */ "./node_modules/svelte/src/runtime/store/index.js");

const selectedVariant = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)({});
const selectedSellingPlanStore = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)(false);

// Id of the selling plan currently chosen, shared between the plan dropdown
// and the buy button so either UI can drive checkout.
const selectedSellingPlanId = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)(null);

// True while the plan dropdown is still showing its placeholder, i.e. the
// shopper has not picked anything yet. The buy button blocks checkout on it.
const planSelectionPending = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)(false);
const updateSelectedVariant = ({
  productId,
  variantObj
}) => {
  selectedVariant.update(contents => {
    contents[productId] = {};
    contents[productId] = variantObj;
    return contents;
  });
};

/***/ }),

/***/ "./js/components/landing-page-buy-box/buy-box.svelte":
/*!***********************************************************!*\
  !*** ./js/components/landing-page-buy-box/buy-box.svelte ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var _variant_options_svelte__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./variant-options.svelte */ "./js/components/landing-page-buy-box/variant-options.svelte");
/* harmony import */ var _variant_description_minimal_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./variant-description-minimal.svelte */ "./js/components/landing-page-buy-box/variant-description-minimal.svelte");
/* harmony import */ var _buy_now_button_svelte__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./buy-now-button.svelte */ "./js/components/landing-page-buy-box/buy-now-button.svelte");
/* js/components/landing-page-buy-box/buy-box.svelte generated by Svelte v4.2.19 */






function create_key_block(ctx) {
  let form;
  let div;
  let variantdescriptionminimal;
  let t0;
  let variantoptions;
  let t1;
  let buynowbutton;
  let div_class_value;
  let form_class_value;
  let current;
  variantdescriptionminimal = new _variant_description_minimal_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
    props: {
      wrapperClass: /*wrapperClass*/ctx[11],
      variantSelectorType: /*settings*/ctx[8].variantSelectorType,
      productId: /*productId*/ctx[9],
      productHandle: /*productHandle*/ctx[6],
      enableShopPayText: /*enableShopPayText*/ctx[7],
      finalDiscountedPrice: /*finalDiscountedPrice*/ctx[2],
      showSubscription: /*settings*/ctx[8].showSubscription,
      discountBgColor: /*settings*/ctx[8].discountBgColor,
      dropdownContent: /*settings*/ctx[8].dropdownContent,
      showSupplyText: /*settings*/ctx[8].showSupplyText !== false,
      supplyTextOverride: /*settings*/ctx[8].supplyTextOverride,
      subscriptionOnly: /*subscriptionOnly*/ctx[13],
      subscriptionNoteLines: [/*settings*/ctx[8].subscriptionNoteLine1, /*settings*/ctx[8].subscriptionNoteLine2],
      hidePriceDecimals: /*settings*/ctx[8].hidePriceDecimals === true
    }
  });
  variantoptions = new _variant_options_svelte__WEBPACK_IMPORTED_MODULE_3__["default"]({
    props: {
      wrapperClass: /*wrapperClass*/ctx[11],
      variants: /*variantList*/ctx[12],
      settings: /*settings*/ctx[8],
      productId: /*productId*/ctx[9],
      sellingPlanGroups: /*sellingPlanGroups*/ctx[10],
      orderDiscount: /*orderDiscount*/ctx[4],
      recurringDiscount: /*nextOrderOnwardsDiscount*/ctx[3],
      subscriptionOnly: /*subscriptionOnly*/ctx[13]
    }
  });
  buynowbutton = new _buy_now_button_svelte__WEBPACK_IMPORTED_MODULE_4__["default"]({
    props: {
      wrapperClass: /*wrapperClass*/ctx[11],
      productId: /*productId*/ctx[9],
      productHandle: /*productHandle*/ctx[6],
      enableShopPayText: /*enableShopPayText*/ctx[7],
      sellingPlanGroups: /*sellingPlanGroups*/ctx[10],
      showSubscription: /*settings*/ctx[8].showSubscription,
      orderDiscount: /*orderDiscount*/ctx[4],
      nextOrderOnwardsDiscount: /*nextOrderOnwardsDiscount*/ctx[3],
      finalDiscountedPrice: /*finalDiscountedPrice*/ctx[2],
      showDiscountText: /*settings*/ctx[8].showDiscountText,
      useCustomBtnText: /*settings*/ctx[8].useCustomBtnText,
      customBtnText: /*settings*/ctx[8].customBtnText,
      dropdownContent: /*settings*/ctx[8].dropdownContent,
      subscriptionOnly: /*subscriptionOnly*/ctx[13],
      hidePriceDecimals: /*settings*/ctx[8].hidePriceDecimals === true
    }
  });
  return {
    c() {
      form = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("form");
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantdescriptionminimal.$$.fragment);
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantoptions.$$.fragment);
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(buynowbutton.$$.fragment);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[11]}__product-info-box${/*planRadiosLayout*/ctx[5] ? ` ${/*wrapperClass*/ctx[11]}__product-info-box--plan-radios` : ''}${/*subscriptionOnly*/ctx[13] ? ` ${/*wrapperClass*/ctx[11]}__product-info-box--subscription-only` : ''}`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(form, "action", "");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(form, "class", form_class_value = `${/*wrapperClass*/ctx[11]}__order-form`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, form, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(form, div);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantdescriptionminimal, div, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantoptions, div, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(buynowbutton, div, null);
      /*form_binding*/
      ctx[25](form);
      current = true;
    },
    p(ctx, dirty) {
      const variantdescriptionminimal_changes = {};
      if (dirty & /*finalDiscountedPrice*/4) variantdescriptionminimal_changes.finalDiscountedPrice = /*finalDiscountedPrice*/ctx[2];
      variantdescriptionminimal.$set(variantdescriptionminimal_changes);
      const variantoptions_changes = {};
      if (dirty & /*orderDiscount*/16) variantoptions_changes.orderDiscount = /*orderDiscount*/ctx[4];
      if (dirty & /*nextOrderOnwardsDiscount*/8) variantoptions_changes.recurringDiscount = /*nextOrderOnwardsDiscount*/ctx[3];
      variantoptions.$set(variantoptions_changes);
      const buynowbutton_changes = {};
      if (dirty & /*orderDiscount*/16) buynowbutton_changes.orderDiscount = /*orderDiscount*/ctx[4];
      if (dirty & /*nextOrderOnwardsDiscount*/8) buynowbutton_changes.nextOrderOnwardsDiscount = /*nextOrderOnwardsDiscount*/ctx[3];
      if (dirty & /*finalDiscountedPrice*/4) buynowbutton_changes.finalDiscountedPrice = /*finalDiscountedPrice*/ctx[2];
      buynowbutton.$set(buynowbutton_changes);
      if (!current || dirty & /*planRadiosLayout*/32 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[11]}__product-info-box${/*planRadiosLayout*/ctx[5] ? ` ${/*wrapperClass*/ctx[11]}__product-info-box--plan-radios` : ''}${/*subscriptionOnly*/ctx[13] ? ` ${/*wrapperClass*/ctx[11]}__product-info-box--subscription-only` : ''}`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantdescriptionminimal.$$.fragment, local);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantoptions.$$.fragment, local);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(buynowbutton.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantdescriptionminimal.$$.fragment, local);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantoptions.$$.fragment, local);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(buynowbutton.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(form);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantdescriptionminimal);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantoptions);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(buynowbutton);
      /*form_binding*/
      ctx[25](null);
    }
  };
}
function create_fragment(ctx) {
  let previous_key = Object.keys(/*$selectedVariant*/ctx[1]).length;
  let key_block_anchor;
  let current;
  let key_block = create_key_block(ctx);
  return {
    c() {
      key_block.c();
      key_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
    },
    m(target, anchor) {
      key_block.m(target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, key_block_anchor, anchor);
      current = true;
    },
    p(ctx, [dirty]) {
      if (dirty & /*$selectedVariant*/2 && (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal)(previous_key, previous_key = Object.keys(/*$selectedVariant*/ctx[1]).length)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(key_block, 1, 1, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
        key_block = create_key_block(ctx);
        key_block.c();
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(key_block, 1);
        key_block.m(key_block_anchor.parentNode, key_block_anchor);
      } else {
        key_block.p(ctx, dirty);
      }
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(key_block);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(key_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(key_block_anchor);
      }
      key_block.d(detaching);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let currentVariant;
  let perVariantBadge;
  let planRadiosLayout;
  let allPlans;
  let selectedPlan;
  let planForPricing;
  let planAdjustments;
  let firstOrderPercent;
  let recurringPercent;
  let orderDiscount;
  let nextOrderOnwardsDiscount;
  let derivedDiscountedPrice;
  let finalDiscountedPrice;
  let $selectedSellingPlanId;
  let $selectedVariant;
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_5__.selectedSellingPlanId, $$value => $$invalidate(24, $selectedSellingPlanId = $$value));
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_5__.selectedVariant, $$value => $$invalidate(1, $selectedVariant = $$value));
  let {
    shopifyData
  } = $$props;
  const {
    variants,
    productHandle,
    enableShopPayText,
    settings,
    productId,
    sellingPlanGroups
  } = shopifyData || {};
  const {
    wrapperClass = "landing-page-buy-box"
  } = settings || {};

  // Sold-out products render an empty variant list; keep the store untouched
  // so selectors fall back to their empty state instead of crashing.
  const variantList = variants || [];
  const variantObj = variantList[variantList.length - 1];
  if (variantObj) {
    (0,_buy_box_store__WEBPACK_IMPORTED_MODULE_5__.updateSelectedVariant)({
      productId,
      variantObj
    });
  }
  const lastVariantId = variantObj?.id;

  // V2 purchase layout: subscription only — no size/frequency selector,
  // no one-time option, plan forced to the first available selling plan.
  const subscriptionOnly = settings?.purchaseLayout === 'subscription_only';
  let formEl;
  function form_binding($$value) {
    svelte_internal__WEBPACK_IMPORTED_MODULE_0__.binding_callbacks[$$value ? 'unshift' : 'push'](() => {
      formEl = $$value;
      $$invalidate(0, formEl);
    });
  }
  $$self.$$set = $$props => {
    if ('shopifyData' in $$props) $$invalidate(14, shopifyData = $$props.shopifyData);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$selectedVariant*/2) {
      $: $$invalidate(16, currentVariant = $selectedVariant[productId]);
    }
    if ($$self.$$.dirty & /*perVariantBadge, currentVariant, formEl*/8454145) {
      $: if ((settings.bestSellerLastVariantOnly || perVariantBadge) && currentVariant && formEl) {
        const section = formEl.closest('[data-buybox-custom]');
        if (section) {
          const isLastVariant = currentVariant.id === lastVariantId;
          const badges = section.querySelectorAll('[data-best-seller-badge]');
          badges.forEach(badge => {
            if (perVariantBadge) {
              // An empty metafield means this variant gets no badge at all
              const text = (currentVariant.badgeText || '').trim();
              badge.textContent = text;
              badge.hidden = !text || settings.bestSellerLastVariantOnly && !isLastVariant;
              return;
            }
            badge.hidden = !isLastVariant;
          });
          const wrappers = section.querySelectorAll('[data-tags-wrapper]');
          wrappers.forEach(wrapper => {
            const hasVisibleChildren = [...wrapper.children].some(child => !child.hidden);
            wrapper.style.marginBottom = hasVisibleChildren ? '' : '0';
          });
        }
      }
    }
    if ($$self.$$.dirty & /*allPlans, $selectedSellingPlanId*/18874368) {
      $: $$invalidate(22, selectedPlan = allPlans.find(plan => String(plan.id) === String($selectedSellingPlanId)));
    }
    if ($$self.$$.dirty & /*selectedPlan, allPlans*/6291456) {
      // Fall back to the first plan so labels can still quote the saving while the
      // shopper is on one-time purchase; pricing stays gated on an actual selection.
      $: $$invalidate(20, planForPricing = selectedPlan || allPlans[0]);
    }
    if ($$self.$$.dirty & /*planForPricing*/1048576) {
      $: $$invalidate(19, planAdjustments = (planForPricing?.price_adjustments || []).filter(adj => adj.value_type === 'percentage'));
    }
    if ($$self.$$.dirty & /*planAdjustments*/524288) {
      $: $$invalidate(17, firstOrderPercent = planAdjustments.find(adj => adj.order_count === 1)?.value ?? planAdjustments[0]?.value);
    }
    if ($$self.$$.dirty & /*planAdjustments, firstOrderPercent*/655360) {
      $: $$invalidate(18, recurringPercent = planAdjustments.find(adj => !adj.order_count)?.value ?? firstOrderPercent);
    }
    if ($$self.$$.dirty & /*currentVariant, firstOrderPercent*/196608) {
      $: $$invalidate(4, orderDiscount = currentVariant?.orderDiscount || firstOrderPercent);
    }
    if ($$self.$$.dirty & /*currentVariant, recurringPercent*/327680) {
      $: $$invalidate(3, nextOrderOnwardsDiscount = currentVariant?.nextOrderOnwardsDiscount || recurringPercent);
    }
    if ($$self.$$.dirty & /*firstOrderPercent, currentVariant*/196608) {
      $: $$invalidate(15, derivedDiscountedPrice = firstOrderPercent && currentVariant?.priceWithoutCurrency ? (parseFloat(String(currentVariant.priceWithoutCurrency).replace(/[^0-9.]/g, '')) * (1 - firstOrderPercent / 100)).toFixed(2) : null);
    }
    if ($$self.$$.dirty & /*currentVariant, derivedDiscountedPrice*/98304) {
      $: $$invalidate(2, finalDiscountedPrice = currentVariant?.finalDiscountedPrice || derivedDiscountedPrice);
    }
  };
  $: $$invalidate(23, perVariantBadge = settings?.bestSellerTagSource === 'variant');

  // Products without the lp_variant_data metafields fall back to the selling
  // plan's own price adjustments, so subscription pricing still works.
  // Frequency radios replace the size selector, so the buy box drops the
  // divider and extra spacing the size layout needs.
  $: $$invalidate(5, planRadiosLayout = settings?.dropdownContent === 'selling_plans' && settings?.variantSelectorType === 'default' && (sellingPlanGroups || []).length > 0);
  $: $$invalidate(21, allPlans = (sellingPlanGroups || []).flatMap(group => group.selling_plans || []));
  return [formEl, $selectedVariant, finalDiscountedPrice, nextOrderOnwardsDiscount, orderDiscount, planRadiosLayout, productHandle, enableShopPayText, settings, productId, sellingPlanGroups, wrapperClass, variantList, subscriptionOnly, shopifyData, derivedDiscountedPrice, currentVariant, firstOrderPercent, recurringPercent, planAdjustments, planForPricing, allPlans, selectedPlan, perVariantBadge, $selectedSellingPlanId, form_binding];
}
class Buy_box extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      shopifyData: 14
    });
  }
  get shopifyData() {
    return this.$$.ctx[14];
  }
  set shopifyData(shopifyData) {
    this.$$set({
      shopifyData
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Buy_box, {
  "shopifyData": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Buy_box);

/***/ }),

/***/ "./js/components/landing-page-buy-box/buy-now-button.svelte":
/*!******************************************************************!*\
  !*** ./js/components/landing-page-buy-box/buy-now-button.svelte ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var _price_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./price-format */ "./js/components/landing-page-buy-box/price-format.js");
/* js/components/landing-page-buy-box/buy-now-button.svelte generated by Svelte v4.2.19 */




function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[41] = list[i];
  const constants_0 = /*selectedSellingPlanGroup*/child_ctx[15] === /*group*/child_ctx[41].id;
  child_ctx[42] = constants_0;
  const constants_1 = /*showSubscription*/child_ctx[3] && /*requiresSellingPlan*/child_ctx[5] && /*sellingPlanGroups*/child_ctx[2][0].id === /*group*/child_ctx[41].id && ! /*selectedSellingPlanGroup*/child_ctx[15];
  child_ctx[43] = constants_1;
  return child_ctx;
}
function get_each_context_1(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[46] = list[i];
  return child_ctx;
}

// (173:0) {#if !subscriptionOnly && showSubscription && !planSelectionInDropdown && sellingPlanGroups && sellingPlanGroups.length > 0}
function create_if_block_4(ctx) {
  let div;
  let fieldset;
  let legend;
  let span;
  let t0;
  let span_class_value;
  let legend_class_value;
  let t1;
  let t2;
  let fieldset_class_value;
  let div_class_value;
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*sellingPlanGroups*/ctx[2]);
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  let if_block = ! /*requiresSellingPlan*/ctx[5] && create_if_block_5(ctx);
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      fieldset = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("fieldset");
      legend = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("legend");
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Frequency");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block) if_block.c();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value = `${/*wrapperClass*/ctx[0]}__radio-legend-label`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(legend, "class", legend_class_value = `${/*wrapperClass*/ctx[0]}__radio-legend`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(fieldset, "class", fieldset_class_value = `${/*wrapperClass*/ctx[0]}__product-subs`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-subscription`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, fieldset);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(fieldset, legend);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(legend, span);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(fieldset, t1);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(fieldset, null);
        }
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(fieldset, t2);
      if (if_block) if_block.m(fieldset, null);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*wrapperClass*/1 && span_class_value !== (span_class_value = `${/*wrapperClass*/ctx[0]}__radio-legend-label`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value);
      }
      if (dirty[0] & /*wrapperClass*/1 && legend_class_value !== (legend_class_value = `${/*wrapperClass*/ctx[0]}__radio-legend`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(legend, "class", legend_class_value);
      }
      if (dirty[0] & /*wrapperClass, sellingPlanGroups, selectedSellingPlan, showSubscription, requiresSellingPlan, handleSellingPlanChange, selectedSellingPlanGroup, orderDiscount, handleSellingPlanGroupChange*/1671277) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*sellingPlanGroups*/ctx[2]);
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(fieldset, t2);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
      if (! /*requiresSellingPlan*/ctx[5]) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block_5(ctx);
          if_block.c();
          if_block.m(fieldset, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
      if (dirty[0] & /*wrapperClass*/1 && fieldset_class_value !== (fieldset_class_value = `${/*wrapperClass*/ctx[0]}__product-subs`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(fieldset, "class", fieldset_class_value);
      }
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-subscription`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
      if (if_block) if_block.d();
    }
  };
}

// (201:20) {#if isGroupSelected || isPreselected}
function create_if_block_6(ctx) {
  let div;
  let div_class_value;
  let each_value_1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*group*/ctx[41].selling_plans);
  let each_blocks = [];
  for (let i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
  }
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-plans`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div, null);
        }
      }
    },
    p(ctx, dirty) {
      if (dirty[0] & /*wrapperClass, sellingPlanGroups, selectedSellingPlan, showSubscription, requiresSellingPlan, handleSellingPlanChange*/589869) {
        each_value_1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*group*/ctx[41].selling_plans);
        let i;
        for (i = 0; i < each_value_1.length; i += 1) {
          const child_ctx = get_each_context_1(ctx, each_value_1, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block_1(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(div, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value_1.length;
      }
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-plans`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
    }
  };
}

// (203:28) {#each group.selling_plans as plan}
function create_each_block_1(ctx) {
  let label;
  let input;
  let input_value_value;
  let input_checked_value;
  let t0;
  let span;
  let t1_value = /*plan*/ctx[46].name + "";
  let t1;
  let label_class_value;
  let mounted;
  let dispose;
  function change_handler_1() {
    return /*change_handler_1*/ctx[36](/*plan*/ctx[46]);
  }
  return {
    c() {
      label = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("label");
      input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "type", "radio");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", "selling_plan");
      input.value = input_value_value = /*plan*/ctx[46].id;
      input.checked = input_checked_value = /*selectedSellingPlan*/ctx[16] === /*plan*/ctx[46].id || /*showSubscription*/ctx[3] && /*requiresSellingPlan*/ctx[5] && /*sellingPlanGroups*/ctx[2][0].selling_plans[0].id === /*plan*/ctx[46].id && ! /*selectedSellingPlan*/ctx[16];
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, label, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, input);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, span);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t1);
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(input, "change", change_handler_1);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty[0] & /*sellingPlanGroups*/4 && input_value_value !== (input_value_value = /*plan*/ctx[46].id)) {
        input.value = input_value_value;
      }
      if (dirty[0] & /*selectedSellingPlan, sellingPlanGroups, showSubscription, requiresSellingPlan*/65580 && input_checked_value !== (input_checked_value = /*selectedSellingPlan*/ctx[16] === /*plan*/ctx[46].id || /*showSubscription*/ctx[3] && /*requiresSellingPlan*/ctx[5] && /*sellingPlanGroups*/ctx[2][0].selling_plans[0].id === /*plan*/ctx[46].id && ! /*selectedSellingPlan*/ctx[16])) {
        input.checked = input_checked_value;
      }
      if (dirty[0] & /*sellingPlanGroups*/4 && t1_value !== (t1_value = /*plan*/ctx[46].name + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, t1_value);
      if (dirty[0] & /*wrapperClass*/1 && label_class_value !== (label_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(label);
      }
      mounted = false;
      dispose();
    }
  };
}

// (180:12) {#each sellingPlanGroups as group}
function create_each_block(ctx) {
  let div;
  let label;
  let input;
  let input_value_value;
  let input_checked_value;
  let t0;
  let span2;
  let span0;
  let t2;
  let span1;
  let t3;
  let t4;
  let t5;
  let span2_class_value;
  let label_class_value;
  let t6;
  let div_class_value;
  let mounted;
  let dispose;
  function change_handler() {
    return /*change_handler*/ctx[35](/*group*/ctx[41]);
  }
  let if_block = (/*isGroupSelected*/ctx[42] || /*isPreselected*/ctx[43]) && create_if_block_6(ctx);
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      label = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("label");
      input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      span0.textContent = "MONTHLY DELIVERY";
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Save ");
      t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*orderDiscount*/ctx[6]);
      t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("% today, delivery every 30 days*");
      t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block) if_block.c();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "type", "radio");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", "selling-plan-group");
      input.value = input_value_value = /*group*/ctx[41].id;
      input.checked = input_checked_value = /*isGroupSelected*/ctx[42] || /*isPreselected*/ctx[43];
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span1, "class", "plans--text");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span2, "class", span2_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option--plans`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-group ${/*wrapperClass*/ctx[0]}__product-subs-group--subscription`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, label);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, input);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, span2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span2, span0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span2, t2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span2, span1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t3);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t4);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t5);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t6);
      if (if_block) if_block.m(div, null);
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(input, "change", change_handler);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty[0] & /*sellingPlanGroups*/4 && input_value_value !== (input_value_value = /*group*/ctx[41].id)) {
        input.value = input_value_value;
      }
      if (dirty[0] & /*selectedSellingPlanGroup, sellingPlanGroups, showSubscription, requiresSellingPlan*/32812 && input_checked_value !== (input_checked_value = /*isGroupSelected*/ctx[42] || /*isPreselected*/ctx[43])) {
        input.checked = input_checked_value;
      }
      if (dirty[0] & /*orderDiscount*/64) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t4, /*orderDiscount*/ctx[6]);
      if (dirty[0] & /*wrapperClass*/1 && span2_class_value !== (span2_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option--plans`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span2, "class", span2_class_value);
      }
      if (dirty[0] & /*wrapperClass*/1 && label_class_value !== (label_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value);
      }
      if (/*isGroupSelected*/ctx[42] || /*isPreselected*/ctx[43]) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block_6(ctx);
          if_block.c();
          if_block.m(div, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-group ${/*wrapperClass*/ctx[0]}__product-subs-group--subscription`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      if (if_block) if_block.d();
      mounted = false;
      dispose();
    }
  };
}

// (220:12) {#if !requiresSellingPlan}
function create_if_block_5(ctx) {
  let div;
  let label;
  let input;
  let input_checked_value;
  let t0;
  let span;
  let label_class_value;
  let div_class_value;
  let mounted;
  let dispose;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      label = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("label");
      input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      span.textContent = "One-time purchase";
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "type", "radio");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", "selling-plan-group");
      input.value = "";
      input.checked = input_checked_value = ! /*selectedSellingPlanGroup*/ctx[15];
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-group`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, label);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, input);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label, span);
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(input, "change", /*change_handler_2*/ctx[37]);
        mounted = true;
      }
    },
    p(ctx, dirty) {
      if (dirty[0] & /*selectedSellingPlanGroup*/32768 && input_checked_value !== (input_checked_value = ! /*selectedSellingPlanGroup*/ctx[15])) {
        input.checked = input_checked_value;
      }
      if (dirty[0] & /*wrapperClass*/1 && label_class_value !== (label_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label, "class", label_class_value);
      }
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-group`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      mounted = false;
      dispose();
    }
  };
}

// (244:12) {:else}
function create_else_block(ctx) {
  let span0;
  let t1;
  let span1;
  let t2;
  let span1_class_value;
  let t3;
  let span2;
  let t4;
  let span2_class_value;
  return {
    c() {
      span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      span0.textContent = "BUY NOW";
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("•");
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*displayPrice*/ctx[17]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span1, "class", span1_class_value = `${/*wrapperClass*/ctx[0]}__checkout-btn-separator`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span2, "class", span2_class_value = `${/*wrapperClass*/ctx[0]}__shopify-buy__btn-price`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, span0, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, span1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t3, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, span2, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span2, t4);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*wrapperClass*/1 && span1_class_value !== (span1_class_value = `${/*wrapperClass*/ctx[0]}__checkout-btn-separator`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span1, "class", span1_class_value);
      }
      if (dirty[0] & /*displayPrice*/131072) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t4, /*displayPrice*/ctx[17]);
      if (dirty[0] & /*wrapperClass*/1 && span2_class_value !== (span2_class_value = `${/*wrapperClass*/ctx[0]}__shopify-buy__btn-price`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span2, "class", span2_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(span0);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t1);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(span1);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t3);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(span2);
      }
    }
  };
}

// (242:12) {#if useCustomBtnText && customBtnText}
function create_if_block_3(ctx) {
  let span;
  let t;
  return {
    c() {
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*customBtnText*/ctx[9]);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, span, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*customBtnText*/512) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, /*customBtnText*/ctx[9]);
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(span);
      }
    }
  };
}

// (251:4) {#if planErrorVisible}
function create_if_block_2(ctx) {
  let p;
  let t;
  let p_class_value;
  let p_id_value;
  return {
    c() {
      p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Please select an option to continue.");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(p, "class", p_class_value = `${/*wrapperClass*/ctx[0]}__plan-error`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(p, "id", p_id_value = `${/*wrapperClass*/ctx[0]}-plan-error`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(p, "role", "alert");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, p, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(p, t);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*wrapperClass*/1 && p_class_value !== (p_class_value = `${/*wrapperClass*/ctx[0]}__plan-error`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(p, "class", p_class_value);
      }
      if (dirty[0] & /*wrapperClass*/1 && p_id_value !== (p_id_value = `${/*wrapperClass*/ctx[0]}-plan-error`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(p, "id", p_id_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(p);
      }
    }
  };
}

// (258:0) {#if !subscriptionOnly && showDiscountText && (orderDiscount || nextOrderOnwardsDiscount)}
function create_if_block_1(ctx) {
  let div;
  let span;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let span_class_value;
  let div_class_value;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("*Save ");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*orderDiscount*/ctx[6]);
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("% today and ");
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*nextOrderOnwardsDiscount*/ctx[7]);
      t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("% on every order thereafter.");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value = `${/*wrapperClass*/ctx[0]}__condition-text`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__condition-container`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, span);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t3);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t4);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*orderDiscount*/64) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, /*orderDiscount*/ctx[6]);
      if (dirty[0] & /*nextOrderOnwardsDiscount*/128) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t3, /*nextOrderOnwardsDiscount*/ctx[7]);
      if (dirty[0] & /*wrapperClass*/1 && span_class_value !== (span_class_value = `${/*wrapperClass*/ctx[0]}__condition-text`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value);
      }
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__condition-container`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}

// (265:0) {#if paymentTerms && enableShopPayText && !subscriptionOnly && !selectedSellingPlanGroup}
function create_if_block(ctx) {
  let div;
  let div_class_value;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__payment-terms`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      div.innerHTML = /*paymentTerms*/ctx[14];
    },
    p(ctx, dirty) {
      if (dirty[0] & /*paymentTerms*/16384) div.innerHTML = /*paymentTerms*/ctx[14];
      ;
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__payment-terms`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}
function create_fragment(ctx) {
  let t0;
  let div1;
  let div0;
  let button;
  let button_class_value;
  let button_aria_describedby_value;
  let div0_class_value;
  let t1;
  let div1_class_value;
  let t2;
  let t3;
  let if_block4_anchor;
  let mounted;
  let dispose;
  let if_block0 = ! /*subscriptionOnly*/ctx[10] && /*showSubscription*/ctx[3] && ! /*planSelectionInDropdown*/ctx[11] && /*sellingPlanGroups*/ctx[2] && /*sellingPlanGroups*/ctx[2].length > 0 && create_if_block_4(ctx);
  function select_block_type(ctx, dirty) {
    if (/*useCustomBtnText*/ctx[8] && /*customBtnText*/ctx[9]) return create_if_block_3;
    return create_else_block;
  }
  let current_block_type = select_block_type(ctx, [-1, -1]);
  let if_block1 = current_block_type(ctx);
  let if_block2 = /*planErrorVisible*/ctx[12] && create_if_block_2(ctx);
  let if_block3 = ! /*subscriptionOnly*/ctx[10] && /*showDiscountText*/ctx[4] && (/*orderDiscount*/ctx[6] || /*nextOrderOnwardsDiscount*/ctx[7]) && create_if_block_1(ctx);
  let if_block4 = /*paymentTerms*/ctx[14] && /*enableShopPayText*/ctx[1] && ! /*subscriptionOnly*/ctx[10] && ! /*selectedSellingPlanGroup*/ctx[15] && create_if_block(ctx);
  return {
    c() {
      if (if_block0) if_block0.c();
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
      if_block1.c();
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block2) if_block2.c();
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block3) if_block3.c();
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block4) if_block4.c();
      if_block4_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "class", button_class_value = `shopify-buy__btn ${/*wrapperClass*/ctx[0]}__shopify-buy__btn`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "type", "button");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "aria-describedby", button_aria_describedby_value = /*planErrorVisible*/ctx[12] ? `${/*wrapperClass*/ctx[0]}-plan-error` : undefined);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ctx[0]}__checkout-btn`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ctx[0]}__product-buy-button`);
    },
    m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t0, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, div0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, button);
      if_block1.m(button, null);
      /*button_binding*/
      ctx[38](button);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t1);
      if (if_block2) if_block2.m(div1, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t2, anchor);
      if (if_block3) if_block3.m(target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t3, anchor);
      if (if_block4) if_block4.m(target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, if_block4_anchor, anchor);
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(button, "click", /*handleBuyBox*/ctx[18]);
        mounted = true;
      }
    },
    p(ctx, dirty) {
      if (! /*subscriptionOnly*/ctx[10] && /*showSubscription*/ctx[3] && ! /*planSelectionInDropdown*/ctx[11] && /*sellingPlanGroups*/ctx[2] && /*sellingPlanGroups*/ctx[2].length > 0) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
        } else {
          if_block0 = create_if_block_4(ctx);
          if_block0.c();
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block1) {
        if_block1.p(ctx, dirty);
      } else {
        if_block1.d(1);
        if_block1 = current_block_type(ctx);
        if (if_block1) {
          if_block1.c();
          if_block1.m(button, null);
        }
      }
      if (dirty[0] & /*wrapperClass*/1 && button_class_value !== (button_class_value = `shopify-buy__btn ${/*wrapperClass*/ctx[0]}__shopify-buy__btn`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "class", button_class_value);
      }
      if (dirty[0] & /*planErrorVisible, wrapperClass*/4097 && button_aria_describedby_value !== (button_aria_describedby_value = /*planErrorVisible*/ctx[12] ? `${/*wrapperClass*/ctx[0]}-plan-error` : undefined)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(button, "aria-describedby", button_aria_describedby_value);
      }
      if (dirty[0] & /*wrapperClass*/1 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ctx[0]}__checkout-btn`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (/*planErrorVisible*/ctx[12]) {
        if (if_block2) {
          if_block2.p(ctx, dirty);
        } else {
          if_block2 = create_if_block_2(ctx);
          if_block2.c();
          if_block2.m(div1, null);
        }
      } else if (if_block2) {
        if_block2.d(1);
        if_block2 = null;
      }
      if (dirty[0] & /*wrapperClass*/1 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ctx[0]}__product-buy-button`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
      if (! /*subscriptionOnly*/ctx[10] && /*showDiscountText*/ctx[4] && (/*orderDiscount*/ctx[6] || /*nextOrderOnwardsDiscount*/ctx[7])) {
        if (if_block3) {
          if_block3.p(ctx, dirty);
        } else {
          if_block3 = create_if_block_1(ctx);
          if_block3.c();
          if_block3.m(t3.parentNode, t3);
        }
      } else if (if_block3) {
        if_block3.d(1);
        if_block3 = null;
      }
      if (/*paymentTerms*/ctx[14] && /*enableShopPayText*/ctx[1] && ! /*subscriptionOnly*/ctx[10] && ! /*selectedSellingPlanGroup*/ctx[15]) {
        if (if_block4) {
          if_block4.p(ctx, dirty);
        } else {
          if_block4 = create_if_block(ctx);
          if_block4.c();
          if_block4.m(if_block4_anchor.parentNode, if_block4_anchor);
        }
      } else if (if_block4) {
        if_block4.d(1);
        if_block4 = null;
      }
    },
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t0);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t2);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t3);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(if_block4_anchor);
      }
      if (if_block0) if_block0.d(detaching);
      if_block1.d();
      /*button_binding*/
      ctx[38](null);
      if (if_block2) if_block2.d();
      if (if_block3) if_block3.d(detaching);
      if (if_block4) if_block4.d(detaching);
      mounted = false;
      dispose();
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let planSelectionInDropdown;
  let selectedSellingPlan;
  let subscriptionsEnabled;
  let displayPriceRaw;
  let displayPrice;
  let $planSelectionPending;
  let $selectedVariant;
  let $selectedSellingPlanStore;
  let $selectedSellingPlanId;
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.planSelectionPending, $$value => $$invalidate(31, $planSelectionPending = $$value));
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedVariant, $$value => $$invalidate(32, $selectedVariant = $$value));
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore, $$value => $$invalidate(33, $selectedSellingPlanStore = $$value));
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId, $$value => $$invalidate(34, $selectedSellingPlanId = $$value));
  let {
    wrapperClass
  } = $$props;
  let {
    productId
  } = $$props;
  let {
    productHandle
  } = $$props;
  let {
    enableShopPayText
  } = $$props;
  let {
    sellingPlanGroups
  } = $$props;
  let {
    showSubscription
  } = $$props;
  let {
    showDiscountText
  } = $$props;
  let {
    requiresSellingPlan = false
  } = $$props;
  let {
    orderDiscount
  } = $$props;
  let {
    nextOrderOnwardsDiscount
  } = $$props;
  let {
    finalDiscountedPrice
  } = $$props;
  let {
    useCustomBtnText = false
  } = $$props;
  let {
    customBtnText = ''
  } = $$props;
  let {
    dropdownContent = 'variants'
  } = $$props;
  let {
    subscriptionOnly = false
  } = $$props;
  let {
    hidePriceDecimals = false
  } = $$props;
  let selectedVariantId, price, priceWithoutCurrency;
  let planErrorVisible = false;
  let buttonEl;
  let paymentTerms = false;
  let selectedSellingPlanGroup = null;
  let isInitialized = false;
  const updateShoppay = async selectedVariantId => {
    const response = await fetch(`/products/${productHandle}?view=payment-terms&variant=${selectedVariantId}`);
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, "text/html");
    const paymentTermsFromFetch = html.querySelector('.shop-pay-terms');
    if (paymentTermsFromFetch) {
      $$invalidate(14, paymentTerms = paymentTermsFromFetch.innerHTML);
      window.dispatchEvent(new Event('resize'));
    }
  };
  const handleBuyBox = async () => {
    // Nothing picked in the frequency dropdown yet — ask for a choice
    // instead of quietly checking out on a one-time purchase.
    if ($planSelectionPending) {
      $$invalidate(12, planErrorVisible = true);
      const select = buttonEl?.closest('form')?.querySelector('select');
      select?.focus();
      select?.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth'
      });
      return;
    }
    try {
      const cartData = {
        id: selectedVariantId,
        quantity: 1
      };

      // Subscription-only checkout must never fall back to a one-time
      // purchase: the forced plan is the offer the price on screen shows.
      const forcedPlanId = subscriptionOnly ? sellingPlanGroups?.[0]?.selling_plans?.[0]?.id : null;
      const planId = selectedSellingPlan || forcedPlanId;
      if (subscriptionsEnabled && planId) {
        cartData.selling_plan = planId;
      }
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartData)
      });
      if (response.ok) {
        // Successfully added to cart, redirect to checkout
        window.location.href = '/checkout';
      } else {
        // Handle error
        const errorData = await response.json();
        console.error('Error adding to cart:', errorData);
        alert('Error adding product to cart. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error adding product to cart. Please try again.');
    }
  };
  const handleSellingPlanChange = planId => {
    _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId.set(planId);
    _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(true);
  };
  const handleSellingPlanGroupChange = groupId => {
    $$invalidate(15, selectedSellingPlanGroup = groupId);
    if (groupId) {
      const group = sellingPlanGroups.find(g => g.id === groupId);
      if (group && group.selling_plans.length > 0) {
        _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId.set(group.selling_plans[0].id);
        _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(true);
      }
    } else {
      _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId.set(null);
      _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(false);
    }
  };
  window.custom = {};
  window.custom["handleBuyBox"] = handleBuyBox;
  const change_handler = group => handleSellingPlanGroupChange(group.id);
  const change_handler_1 = plan => handleSellingPlanChange(plan.id);
  const change_handler_2 = () => handleSellingPlanGroupChange(null);
  function button_binding($$value) {
    svelte_internal__WEBPACK_IMPORTED_MODULE_0__.binding_callbacks[$$value ? 'unshift' : 'push'](() => {
      buttonEl = $$value;
      $$invalidate(13, buttonEl);
    });
  }
  $$self.$$set = $$props => {
    if ('wrapperClass' in $$props) $$invalidate(0, wrapperClass = $$props.wrapperClass);
    if ('productId' in $$props) $$invalidate(21, productId = $$props.productId);
    if ('productHandle' in $$props) $$invalidate(22, productHandle = $$props.productHandle);
    if ('enableShopPayText' in $$props) $$invalidate(1, enableShopPayText = $$props.enableShopPayText);
    if ('sellingPlanGroups' in $$props) $$invalidate(2, sellingPlanGroups = $$props.sellingPlanGroups);
    if ('showSubscription' in $$props) $$invalidate(3, showSubscription = $$props.showSubscription);
    if ('showDiscountText' in $$props) $$invalidate(4, showDiscountText = $$props.showDiscountText);
    if ('requiresSellingPlan' in $$props) $$invalidate(5, requiresSellingPlan = $$props.requiresSellingPlan);
    if ('orderDiscount' in $$props) $$invalidate(6, orderDiscount = $$props.orderDiscount);
    if ('nextOrderOnwardsDiscount' in $$props) $$invalidate(7, nextOrderOnwardsDiscount = $$props.nextOrderOnwardsDiscount);
    if ('finalDiscountedPrice' in $$props) $$invalidate(23, finalDiscountedPrice = $$props.finalDiscountedPrice);
    if ('useCustomBtnText' in $$props) $$invalidate(8, useCustomBtnText = $$props.useCustomBtnText);
    if ('customBtnText' in $$props) $$invalidate(9, customBtnText = $$props.customBtnText);
    if ('dropdownContent' in $$props) $$invalidate(24, dropdownContent = $$props.dropdownContent);
    if ('subscriptionOnly' in $$props) $$invalidate(10, subscriptionOnly = $$props.subscriptionOnly);
    if ('hidePriceDecimals' in $$props) $$invalidate(25, hidePriceDecimals = $$props.hidePriceDecimals);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[1] & /*$planSelectionPending*/1) {
      // Clear the warning as soon as the shopper picks something
      $: if (!$planSelectionPending) $$invalidate(12, planErrorVisible = false);
    }
    if ($$self.$$.dirty[0] & /*dropdownContent*/16777216) {
      // When the size dropdown is showing plans, it owns plan selection —
      // the radio list below is hidden and the store is the single source of truth.
      $: $$invalidate(11, planSelectionInDropdown = dropdownContent === 'selling_plans');
    }
    if ($$self.$$.dirty[1] & /*$selectedSellingPlanId*/8) {
      $: $$invalidate(16, selectedSellingPlan = $selectedSellingPlanId);
    }
    if ($$self.$$.dirty[0] & /*subscriptionOnly, sellingPlanGroups, isInitialized*/268436484) {
      // Subscription-only layout has no UI to pick a plan, so the first plan of
      // the first group is locked in as soon as the data is available.
      $: if (subscriptionOnly && sellingPlanGroups && sellingPlanGroups.length > 0 && !isInitialized) {
        $$invalidate(15, selectedSellingPlanGroup = sellingPlanGroups[0].id);
        _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId.set(sellingPlanGroups[0].selling_plans[0].id);
        _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(true);
        $$invalidate(28, isInitialized = true);
      }
    }
    if ($$self.$$.dirty[0] & /*subscriptionOnly, planSelectionInDropdown, sellingPlanGroups, isInitialized*/268438532) {
      $: if (!subscriptionOnly && !planSelectionInDropdown && sellingPlanGroups && sellingPlanGroups.length > 0 && !isInitialized) {
        $$invalidate(15, selectedSellingPlanGroup = sellingPlanGroups[0].id);
        _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId.set(sellingPlanGroups[0].selling_plans[0].id);
        _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(true);
        $$invalidate(28, isInitialized = true);
      }
    }
    if ($$self.$$.dirty[0] & /*subscriptionOnly, showSubscription, planSelectionInDropdown*/3080) {
      // Reset subscription state when subscriptions are switched off entirely
      $: if (!subscriptionOnly && !showSubscription && !planSelectionInDropdown) {
        $$invalidate(15, selectedSellingPlanGroup = null);
        _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId.set(null);
        _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(false);
      }
    }
    if ($$self.$$.dirty[0] & /*subscriptionOnly, showSubscription, planSelectionInDropdown*/3080) {
      $: $$invalidate(29, subscriptionsEnabled = subscriptionOnly || showSubscription || planSelectionInDropdown);
    }
    if ($$self.$$.dirty[0] & /*productId*/2097152 | $$self.$$.dirty[1] & /*$selectedVariant*/2) {
      $: {
        const variant = $selectedVariant[productId];
        $$invalidate(26, selectedVariantId = variant?.id);
        price = variant?.price;
        $$invalidate(27, priceWithoutCurrency = variant?.priceWithoutCurrency);
      }
    }
    if ($$self.$$.dirty[0] & /*subscriptionsEnabled, priceWithoutCurrency, finalDiscountedPrice*/679477248 | $$self.$$.dirty[1] & /*$selectedSellingPlanStore*/4) {
      $: $$invalidate(30, displayPriceRaw = (() => {
        if (!subscriptionsEnabled) {
          // Always use regular price when subscriptions are hidden
          return priceWithoutCurrency;
        } else if ($selectedSellingPlanStore && finalDiscountedPrice && !isNaN(parseFloat(finalDiscountedPrice))) {
          // Use subscription price when subscriptions are shown and selected
          return parseFloat(finalDiscountedPrice);
        } else {
          // Use regular price when subscriptions are shown but not selected
          return priceWithoutCurrency;
        }
      })());
    }
    if ($$self.$$.dirty[0] & /*displayPriceRaw, hidePriceDecimals*/1107296256) {
      $: $$invalidate(17, displayPrice = (0,_price_format__WEBPACK_IMPORTED_MODULE_3__.formatPrice)(displayPriceRaw, hidePriceDecimals));
    }
    if ($$self.$$.dirty[0] & /*selectedVariantId*/67108864) {
      $: if (selectedVariantId) updateShoppay(selectedVariantId);
    }
  };
  return [wrapperClass, enableShopPayText, sellingPlanGroups, showSubscription, showDiscountText, requiresSellingPlan, orderDiscount, nextOrderOnwardsDiscount, useCustomBtnText, customBtnText, subscriptionOnly, planSelectionInDropdown, planErrorVisible, buttonEl, paymentTerms, selectedSellingPlanGroup, selectedSellingPlan, displayPrice, handleBuyBox, handleSellingPlanChange, handleSellingPlanGroupChange, productId, productHandle, finalDiscountedPrice, dropdownContent, hidePriceDecimals, selectedVariantId, priceWithoutCurrency, isInitialized, subscriptionsEnabled, displayPriceRaw, $planSelectionPending, $selectedVariant, $selectedSellingPlanStore, $selectedSellingPlanId, change_handler, change_handler_1, change_handler_2, button_binding];
}
class Buy_now_button extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      wrapperClass: 0,
      productId: 21,
      productHandle: 22,
      enableShopPayText: 1,
      sellingPlanGroups: 2,
      showSubscription: 3,
      showDiscountText: 4,
      requiresSellingPlan: 5,
      orderDiscount: 6,
      nextOrderOnwardsDiscount: 7,
      finalDiscountedPrice: 23,
      useCustomBtnText: 8,
      customBtnText: 9,
      dropdownContent: 24,
      subscriptionOnly: 10,
      hidePriceDecimals: 25
    }, null, [-1, -1]);
  }
  get wrapperClass() {
    return this.$$.ctx[0];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get productId() {
    return this.$$.ctx[21];
  }
  set productId(productId) {
    this.$$set({
      productId
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get productHandle() {
    return this.$$.ctx[22];
  }
  set productHandle(productHandle) {
    this.$$set({
      productHandle
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get enableShopPayText() {
    return this.$$.ctx[1];
  }
  set enableShopPayText(enableShopPayText) {
    this.$$set({
      enableShopPayText
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get sellingPlanGroups() {
    return this.$$.ctx[2];
  }
  set sellingPlanGroups(sellingPlanGroups) {
    this.$$set({
      sellingPlanGroups
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get showSubscription() {
    return this.$$.ctx[3];
  }
  set showSubscription(showSubscription) {
    this.$$set({
      showSubscription
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get showDiscountText() {
    return this.$$.ctx[4];
  }
  set showDiscountText(showDiscountText) {
    this.$$set({
      showDiscountText
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get requiresSellingPlan() {
    return this.$$.ctx[5];
  }
  set requiresSellingPlan(requiresSellingPlan) {
    this.$$set({
      requiresSellingPlan
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get orderDiscount() {
    return this.$$.ctx[6];
  }
  set orderDiscount(orderDiscount) {
    this.$$set({
      orderDiscount
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get nextOrderOnwardsDiscount() {
    return this.$$.ctx[7];
  }
  set nextOrderOnwardsDiscount(nextOrderOnwardsDiscount) {
    this.$$set({
      nextOrderOnwardsDiscount
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get finalDiscountedPrice() {
    return this.$$.ctx[23];
  }
  set finalDiscountedPrice(finalDiscountedPrice) {
    this.$$set({
      finalDiscountedPrice
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get useCustomBtnText() {
    return this.$$.ctx[8];
  }
  set useCustomBtnText(useCustomBtnText) {
    this.$$set({
      useCustomBtnText
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get customBtnText() {
    return this.$$.ctx[9];
  }
  set customBtnText(customBtnText) {
    this.$$set({
      customBtnText
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get dropdownContent() {
    return this.$$.ctx[24];
  }
  set dropdownContent(dropdownContent) {
    this.$$set({
      dropdownContent
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get subscriptionOnly() {
    return this.$$.ctx[10];
  }
  set subscriptionOnly(subscriptionOnly) {
    this.$$set({
      subscriptionOnly
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get hidePriceDecimals() {
    return this.$$.ctx[25];
  }
  set hidePriceDecimals(hidePriceDecimals) {
    this.$$set({
      hidePriceDecimals
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Buy_now_button, {
  "wrapperClass": {},
  "productId": {},
  "productHandle": {},
  "enableShopPayText": {},
  "sellingPlanGroups": {},
  "showSubscription": {},
  "showDiscountText": {},
  "requiresSellingPlan": {
    "type": "Boolean"
  },
  "orderDiscount": {},
  "nextOrderOnwardsDiscount": {},
  "finalDiscountedPrice": {},
  "useCustomBtnText": {
    "type": "Boolean"
  },
  "customBtnText": {},
  "dropdownContent": {},
  "subscriptionOnly": {
    "type": "Boolean"
  },
  "hidePriceDecimals": {
    "type": "Boolean"
  }
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Buy_now_button);

/***/ }),

/***/ "./js/components/landing-page-buy-box/plan-dropdown-selector.svelte":
/*!**************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/plan-dropdown-selector.svelte ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! svelte */ "./node_modules/svelte/src/runtime/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* js/components/landing-page-buy-box/plan-dropdown-selector.svelte generated by Svelte v4.2.19 */




function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[13] = list[i];
  return child_ctx;
}

// (58:0) {#if planOptions.length}
function create_if_block(ctx) {
  let div1;
  let t;
  let div0;
  let select;
  let if_block1_anchor;
  let if_block2_anchor;
  let select_class_value;
  let select_aria_label_value;
  let div0_class_value;
  let div1_class_value;
  let mounted;
  let dispose;
  let if_block0 = /*label*/ctx[1] && create_if_block_3(ctx);
  let if_block1 = /*usePlaceholder*/ctx[7] && create_if_block_2(ctx);
  let if_block2 = /*showOneTime*/ctx[3] && create_if_block_1(ctx);
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*planOptions*/ctx[6]);
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  return {
    c() {
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      if (if_block0) if_block0.c();
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      select = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("select");
      if (if_block1) if_block1.c();
      if_block1_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
      if (if_block2) if_block2.c();
      if_block2_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "class", select_class_value = `${/*wrapperClass*/ctx[0]}__product-dropdown`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "aria-label", select_aria_label_value = /*label*/ctx[1] || "Select a purchase option");
      if (/*selected*/ctx[5] === void 0) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_render_callback)(() => /*select_change_handler*/ctx[11].call(select));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ctx[0]}__select-wrapper`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `
    ${/*wrapperClass*/ctx[0]}__product-info-row
    ${/*wrapperClass*/ctx[0]}__product-more-options
    ${/*wrapperClass*/ctx[0]}__dropdown-selector
  `);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
      if (if_block0) if_block0.m(div1, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, div0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, select);
      if (if_block1) if_block1.m(select, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(select, if_block1_anchor);
      if (if_block2) if_block2.m(select, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(select, if_block2_anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(select, null);
        }
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_option)(select, /*selected*/ctx[5], true);
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(select, "change", /*select_change_handler*/ctx[11]);
        mounted = true;
      }
    },
    p(ctx, dirty) {
      if (/*label*/ctx[1]) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
        } else {
          if_block0 = create_if_block_3(ctx);
          if_block0.c();
          if_block0.m(div1, t);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (/*usePlaceholder*/ctx[7]) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
        } else {
          if_block1 = create_if_block_2(ctx);
          if_block1.c();
          if_block1.m(select, if_block1_anchor);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (/*showOneTime*/ctx[3]) {
        if (if_block2) {
          if_block2.p(ctx, dirty);
        } else {
          if_block2 = create_if_block_1(ctx);
          if_block2.c();
          if_block2.m(select, if_block2_anchor);
        }
      } else if (if_block2) {
        if_block2.d(1);
        if_block2 = null;
      }
      if (dirty & /*planOptions*/64) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*planOptions*/ctx[6]);
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(select, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
      if (dirty & /*wrapperClass*/1 && select_class_value !== (select_class_value = `${/*wrapperClass*/ctx[0]}__product-dropdown`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "class", select_class_value);
      }
      if (dirty & /*label*/2 && select_aria_label_value !== (select_aria_label_value = /*label*/ctx[1] || "Select a purchase option")) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "aria-label", select_aria_label_value);
      }
      if (dirty & /*selected, planOptions, ONE_TIME, PLACEHOLDER*/96) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_option)(select, /*selected*/ctx[5]);
      }
      if (dirty & /*wrapperClass*/1 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ctx[0]}__select-wrapper`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (dirty & /*wrapperClass*/1 && div1_class_value !== (div1_class_value = `
    ${/*wrapperClass*/ctx[0]}__product-info-row
    ${/*wrapperClass*/ctx[0]}__product-more-options
    ${/*wrapperClass*/ctx[0]}__dropdown-selector
  `)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
      }
      if (if_block0) if_block0.d();
      if (if_block1) if_block1.d();
      if (if_block2) if_block2.d();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
      mounted = false;
      dispose();
    }
  };
}

// (66:4) {#if label}
function create_if_block_3(ctx) {
  let div;
  let t;
  let div_class_value;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*label*/ctx[1]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-info-heading`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t);
    },
    p(ctx, dirty) {
      if (dirty & /*label*/2) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, /*label*/ctx[1]);
      if (dirty & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-info-heading`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}

// (75:8) {#if usePlaceholder}
function create_if_block_2(ctx) {
  let option;
  let t;
  return {
    c() {
      option = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("option");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*placeholderLabel*/ctx[4]);
      option.__value = PLACEHOLDER;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(option, option.__value);
      option.disabled = true;
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, option, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(option, t);
    },
    p(ctx, dirty) {
      if (dirty & /*placeholderLabel*/16) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, /*placeholderLabel*/ctx[4]);
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(option);
      }
    }
  };
}

// (78:8) {#if showOneTime}
function create_if_block_1(ctx) {
  let option;
  let t;
  return {
    c() {
      option = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("option");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*oneTimeLabel*/ctx[2]);
      option.__value = ONE_TIME;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(option, option.__value);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, option, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(option, t);
    },
    p(ctx, dirty) {
      if (dirty & /*oneTimeLabel*/4) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, /*oneTimeLabel*/ctx[2]);
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(option);
      }
    }
  };
}

// (81:8) {#each planOptions as plan}
function create_each_block(ctx) {
  let option;
  let t_value = /*plan*/ctx[13].name + "";
  let t;
  let option_value_value;
  return {
    c() {
      option = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("option");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
      option.__value = option_value_value = /*plan*/ctx[13].id;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(option, option.__value);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, option, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(option, t);
    },
    p(ctx, dirty) {
      if (dirty & /*planOptions*/64 && t_value !== (t_value = /*plan*/ctx[13].name + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, t_value);
      if (dirty & /*planOptions*/64 && option_value_value !== (option_value_value = /*plan*/ctx[13].id)) {
        option.__value = option_value_value;
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(option, option.__value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(option);
      }
    }
  };
}
function create_fragment(ctx) {
  let if_block_anchor;
  let if_block = /*planOptions*/ctx[6].length && create_if_block(ctx);
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, if_block_anchor, anchor);
    },
    p(ctx, [dirty]) {
      if (/*planOptions*/ctx[6].length) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block(ctx);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(if_block_anchor);
      }
      if (if_block) if_block.d(detaching);
    }
  };
}
const ONE_TIME = "";
const PLACEHOLDER = "__placeholder__";
function instance($$self, $$props, $$invalidate) {
  let planOptions;
  let usePlaceholder;
  let initialValue;
  let {
    sellingPlanGroups = []
  } = $$props;
  let {
    wrapperClass
  } = $$props;
  let {
    label = "Select Size"
  } = $$props;
  let {
    oneTimeLabel = "One-time purchase"
  } = $$props;
  let {
    showOneTime = true
  } = $$props;
  let {
    defaultPlan = "first"
  } = $$props;
  let {
    placeholderLabel = "Option"
  } = $$props;
  let selected = null;
  const applySelection = value => {
    // Placeholder means "nothing chosen yet": no plan, and checkout stays shut
    // until the shopper picks an option.
    _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.planSelectionPending.set(value === PLACEHOLDER);
    if (value === ONE_TIME || value === PLACEHOLDER) {
      _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedSellingPlanId.set(null);
      _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedSellingPlanStore.set(false);
      return;
    }
    _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedSellingPlanId.set(value);
    _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedSellingPlanStore.set(true);
  };

  // Another buy box on the page must not inherit this one's pending state
  (0,svelte__WEBPACK_IMPORTED_MODULE_2__.onDestroy)(() => _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.planSelectionPending.set(false));
  function select_change_handler() {
    selected = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_value)(this);
    $$invalidate(5, selected), $$invalidate(6, planOptions), $$invalidate(3, showOneTime), $$invalidate(10, initialValue), $$invalidate(8, sellingPlanGroups), $$invalidate(7, usePlaceholder), $$invalidate(9, defaultPlan), $$invalidate(4, placeholderLabel);
    $$invalidate(6, planOptions), $$invalidate(8, sellingPlanGroups);
  }
  $$self.$$set = $$props => {
    if ('sellingPlanGroups' in $$props) $$invalidate(8, sellingPlanGroups = $$props.sellingPlanGroups);
    if ('wrapperClass' in $$props) $$invalidate(0, wrapperClass = $$props.wrapperClass);
    if ('label' in $$props) $$invalidate(1, label = $$props.label);
    if ('oneTimeLabel' in $$props) $$invalidate(2, oneTimeLabel = $$props.oneTimeLabel);
    if ('showOneTime' in $$props) $$invalidate(3, showOneTime = $$props.showOneTime);
    if ('defaultPlan' in $$props) $$invalidate(9, defaultPlan = $$props.defaultPlan);
    if ('placeholderLabel' in $$props) $$invalidate(4, placeholderLabel = $$props.placeholderLabel);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*sellingPlanGroups*/256) {
      // Flatten every group's plans into a single option list
      $: $$invalidate(6, planOptions = (sellingPlanGroups || []).flatMap(group => (group.selling_plans || []).map(plan => ({
        id: String(plan.id),
        name: plan.name,
        groupName: group.name
      }))));
    }
    if ($$self.$$.dirty & /*defaultPlan, placeholderLabel*/528) {
      // `defaultPlan` decides what the shopper sees before they touch the dropdown
      $: $$invalidate(7, usePlaceholder = defaultPlan === "placeholder" && !!placeholderLabel);
    }
    if ($$self.$$.dirty & /*usePlaceholder, defaultPlan, planOptions*/704) {
      $: $$invalidate(10, initialValue = (() => {
        if (usePlaceholder) return PLACEHOLDER;
        if (defaultPlan === "one_time" || !planOptions.length) return ONE_TIME;
        return planOptions[0].id;
      })());
    }
    if ($$self.$$.dirty & /*selected, planOptions, showOneTime, initialValue*/1128) {
      $: if (selected === null && (planOptions.length || !showOneTime)) {
        $$invalidate(5, selected = initialValue);
      }
    }
    if ($$self.$$.dirty & /*selected*/32) {
      $: applySelection(selected), selected;
    }
  };
  return [wrapperClass, label, oneTimeLabel, showOneTime, placeholderLabel, selected, planOptions, usePlaceholder, sellingPlanGroups, defaultPlan, initialValue, select_change_handler];
}
class Plan_dropdown_selector extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      sellingPlanGroups: 8,
      wrapperClass: 0,
      label: 1,
      oneTimeLabel: 2,
      showOneTime: 3,
      defaultPlan: 9,
      placeholderLabel: 4
    });
  }
  get sellingPlanGroups() {
    return this.$$.ctx[8];
  }
  set sellingPlanGroups(sellingPlanGroups) {
    this.$$set({
      sellingPlanGroups
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get wrapperClass() {
    return this.$$.ctx[0];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get label() {
    return this.$$.ctx[1];
  }
  set label(label) {
    this.$$set({
      label
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get oneTimeLabel() {
    return this.$$.ctx[2];
  }
  set oneTimeLabel(oneTimeLabel) {
    this.$$set({
      oneTimeLabel
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get showOneTime() {
    return this.$$.ctx[3];
  }
  set showOneTime(showOneTime) {
    this.$$set({
      showOneTime
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get defaultPlan() {
    return this.$$.ctx[9];
  }
  set defaultPlan(defaultPlan) {
    this.$$set({
      defaultPlan
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get placeholderLabel() {
    return this.$$.ctx[4];
  }
  set placeholderLabel(placeholderLabel) {
    this.$$set({
      placeholderLabel
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Plan_dropdown_selector, {
  "sellingPlanGroups": {},
  "wrapperClass": {},
  "label": {},
  "oneTimeLabel": {},
  "showOneTime": {
    "type": "Boolean"
  },
  "defaultPlan": {},
  "placeholderLabel": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Plan_dropdown_selector);

/***/ }),

/***/ "./js/components/landing-page-buy-box/plan-radio-selector.svelte":
/*!***********************************************************************!*\
  !*** ./js/components/landing-page-buy-box/plan-radio-selector.svelte ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* js/components/landing-page-buy-box/plan-radio-selector.svelte generated by Svelte v4.2.19 */



function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[18] = list[i];
  return child_ctx;
}

// (55:0) {#if planOptions.length}
function create_if_block(ctx) {
  let div;
  let fieldset;
  let t0;
  let t1;
  let fieldset_class_value;
  let div_class_value;
  let if_block0 = /*label*/ctx[1] && create_if_block_3(ctx);
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*planOptions*/ctx[6]);
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  let if_block1 = /*showOneTime*/ctx[3] && create_if_block_1(ctx);
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      fieldset = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("fieldset");
      if (if_block0) if_block0.c();
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block1) if_block1.c();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(fieldset, "class", fieldset_class_value = `${/*wrapperClass*/ctx[0]}__product-subs`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-subscription ${/*wrapperClass*/ctx[0]}__plan-radios`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, fieldset);
      if (if_block0) if_block0.m(fieldset, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(fieldset, t0);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(fieldset, null);
        }
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(fieldset, t1);
      if (if_block1) if_block1.m(fieldset, null);
    },
    p(ctx, dirty) {
      if (/*label*/ctx[1]) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
        } else {
          if_block0 = create_if_block_3(ctx);
          if_block0.c();
          if_block0.m(fieldset, t0);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (dirty & /*wrapperClass, subscribeNote, subscribeText, planOptions, selected*/241) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*planOptions*/ctx[6]);
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(fieldset, t1);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
      if (/*showOneTime*/ctx[3]) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
        } else {
          if_block1 = create_if_block_1(ctx);
          if_block1.c();
          if_block1.m(fieldset, null);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (dirty & /*wrapperClass*/1 && fieldset_class_value !== (fieldset_class_value = `${/*wrapperClass*/ctx[0]}__product-subs`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(fieldset, "class", fieldset_class_value);
      }
      if (dirty & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-subscription ${/*wrapperClass*/ctx[0]}__plan-radios`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      if (if_block0) if_block0.d();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
      if (if_block1) if_block1.d();
    }
  };
}

// (58:6) {#if label}
function create_if_block_3(ctx) {
  let legend;
  let span;
  let t;
  let span_class_value;
  let legend_class_value;
  return {
    c() {
      legend = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("legend");
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*label*/ctx[1]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value = `${/*wrapperClass*/ctx[0]}__radio-legend-label`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(legend, "class", legend_class_value = `${/*wrapperClass*/ctx[0]}__radio-legend`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, legend, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(legend, span);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t);
    },
    p(ctx, dirty) {
      if (dirty & /*label*/2) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, /*label*/ctx[1]);
      if (dirty & /*wrapperClass*/1 && span_class_value !== (span_class_value = `${/*wrapperClass*/ctx[0]}__radio-legend-label`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", span_class_value);
      }
      if (dirty & /*wrapperClass*/1 && legend_class_value !== (legend_class_value = `${/*wrapperClass*/ctx[0]}__radio-legend`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(legend, "class", legend_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(legend);
      }
    }
  };
}

// (70:14) {#if subscribeNote}
function create_if_block_2(ctx) {
  let span;
  let t;
  return {
    c() {
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*subscribeNote*/ctx[4]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span, "class", "plans--text");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, span, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t);
    },
    p(ctx, dirty) {
      if (dirty & /*subscribeNote*/16) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, /*subscribeNote*/ctx[4]);
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(span);
      }
    }
  };
}

// (64:6) {#each planOptions as plan}
function create_each_block(ctx) {
  let div;
  let label_1;
  let input;
  let input_name_value;
  let input_value_value;
  let value_has_changed = false;
  let t0;
  let span1;
  let span0;
  let t1_value = (/*subscribeText*/ctx[7] || /*plan*/ctx[18].name) + "";
  let t1;
  let t2;
  let span1_class_value;
  let label_1_class_value;
  let div_class_value;
  let binding_group;
  let mounted;
  let dispose;
  let if_block = /*subscribeNote*/ctx[4] && create_if_block_2(ctx);
  binding_group = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init_binding_group)(/*$$binding_groups*/ctx[15][0]);
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      label_1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("label");
      input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block) if_block.c();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "type", "radio");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", input_name_value = `plan-${/*wrapperClass*/ctx[0]}`);
      input.__value = input_value_value = /*plan*/ctx[18].id;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(input, input.__value);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span1, "class", span1_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option--plans`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label_1, "class", label_1_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-group ${/*wrapperClass*/ctx[0]}__product-subs-group--subscription`);
      binding_group.p(input);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, label_1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label_1, input);
      input.checked = input.__value === /*selected*/ctx[5];
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label_1, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label_1, span1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, span0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span0, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t2);
      if (if_block) if_block.m(span1, null);
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(input, "change", /*input_change_handler*/ctx[14]);
        mounted = true;
      }
    },
    p(ctx, dirty) {
      if (dirty & /*wrapperClass*/1 && input_name_value !== (input_name_value = `plan-${/*wrapperClass*/ctx[0]}`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", input_name_value);
      }
      if (dirty & /*planOptions*/64 && input_value_value !== (input_value_value = /*plan*/ctx[18].id)) {
        input.__value = input_value_value;
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(input, input.__value);
        value_has_changed = true;
      }
      if (value_has_changed || dirty & /*selected*/32) {
        input.checked = input.__value === /*selected*/ctx[5];
      }
      if (dirty & /*subscribeText, planOptions*/192 && t1_value !== (t1_value = (/*subscribeText*/ctx[7] || /*plan*/ctx[18].name) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, t1_value);
      if (/*subscribeNote*/ctx[4]) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block_2(ctx);
          if_block.c();
          if_block.m(span1, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
      if (dirty & /*wrapperClass*/1 && span1_class_value !== (span1_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option--plans`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span1, "class", span1_class_value);
      }
      if (dirty & /*wrapperClass*/1 && label_1_class_value !== (label_1_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label_1, "class", label_1_class_value);
      }
      if (dirty & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-group ${/*wrapperClass*/ctx[0]}__product-subs-group--subscription`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      if (if_block) if_block.d();
      binding_group.r();
      mounted = false;
      dispose();
    }
  };
}

// (78:6) {#if showOneTime}
function create_if_block_1(ctx) {
  let div;
  let label_1;
  let input;
  let input_name_value;
  let t0;
  let span;
  let t1;
  let label_1_class_value;
  let div_class_value;
  let binding_group;
  let mounted;
  let dispose;
  binding_group = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init_binding_group)(/*$$binding_groups*/ctx[15][0]);
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      label_1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("label");
      input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*oneTimeLabel*/ctx[2]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "type", "radio");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", input_name_value = `plan-${/*wrapperClass*/ctx[0]}`);
      input.__value = ONE_TIME;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(input, input.__value);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label_1, "class", label_1_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-group`);
      binding_group.p(input);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, label_1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label_1, input);
      input.checked = input.__value === /*selected*/ctx[5];
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label_1, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(label_1, span);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span, t1);
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(input, "change", /*input_change_handler_1*/ctx[16]);
        mounted = true;
      }
    },
    p(ctx, dirty) {
      if (dirty & /*wrapperClass*/1 && input_name_value !== (input_name_value = `plan-${/*wrapperClass*/ctx[0]}`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(input, "name", input_name_value);
      }
      if (dirty & /*selected*/32) {
        input.checked = input.__value === /*selected*/ctx[5];
      }
      if (dirty & /*oneTimeLabel*/4) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, /*oneTimeLabel*/ctx[2]);
      if (dirty & /*wrapperClass*/1 && label_1_class_value !== (label_1_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-option`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(label_1, "class", label_1_class_value);
      }
      if (dirty & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-subs-group`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      binding_group.r();
      mounted = false;
      dispose();
    }
  };
}
function create_fragment(ctx) {
  let if_block_anchor;
  let if_block = /*planOptions*/ctx[6].length && create_if_block(ctx);
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
    },
    m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, if_block_anchor, anchor);
    },
    p(ctx, [dirty]) {
      if (/*planOptions*/ctx[6].length) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block(ctx);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(if_block_anchor);
      }
      if (if_block) if_block.d(detaching);
    }
  };
}
const ONE_TIME = "";

// `{discount}` lets merchants keep the copy in the theme editor while the
// number still comes from the variant metafield.
const DEFAULT_SUBSCRIBE_LABEL = "Subscribe + save {discount}%";
function instance($$self, $$props, $$invalidate) {
  let planOptions;
  let subscribeText;
  let initialValue;
  let {
    sellingPlanGroups = []
  } = $$props;
  let {
    wrapperClass
  } = $$props;
  let {
    label = "Frequency"
  } = $$props;
  let {
    oneTimeLabel = "One time purchase"
  } = $$props;
  let {
    showOneTime = true
  } = $$props;
  let {
    defaultPlan = "first"
  } = $$props;
  let {
    subscribeLabel = "Subscribe + save {discount}%"
  } = $$props;
  let {
    subscribeNote = "(delivery every 30 days)"
  } = $$props;
  let {
    orderDiscount = ""
  } = $$props;
  let {
    recurringDiscount = ""
  } = $$props;
  let selected = null;
  const applySelection = value => {
    if (value === ONE_TIME) {
      _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId.set(null);
      _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(false);
      return;
    }
    _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanId.set(value);
    _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedSellingPlanStore.set(true);
  };
  const $$binding_groups = [[]];
  function input_change_handler() {
    selected = this.__value;
    $$invalidate(5, selected), $$invalidate(6, planOptions), $$invalidate(13, initialValue), $$invalidate(8, sellingPlanGroups), $$invalidate(9, defaultPlan);
  }
  function input_change_handler_1() {
    selected = this.__value;
    $$invalidate(5, selected), $$invalidate(6, planOptions), $$invalidate(13, initialValue), $$invalidate(8, sellingPlanGroups), $$invalidate(9, defaultPlan);
  }
  $$self.$$set = $$props => {
    if ('sellingPlanGroups' in $$props) $$invalidate(8, sellingPlanGroups = $$props.sellingPlanGroups);
    if ('wrapperClass' in $$props) $$invalidate(0, wrapperClass = $$props.wrapperClass);
    if ('label' in $$props) $$invalidate(1, label = $$props.label);
    if ('oneTimeLabel' in $$props) $$invalidate(2, oneTimeLabel = $$props.oneTimeLabel);
    if ('showOneTime' in $$props) $$invalidate(3, showOneTime = $$props.showOneTime);
    if ('defaultPlan' in $$props) $$invalidate(9, defaultPlan = $$props.defaultPlan);
    if ('subscribeLabel' in $$props) $$invalidate(10, subscribeLabel = $$props.subscribeLabel);
    if ('subscribeNote' in $$props) $$invalidate(4, subscribeNote = $$props.subscribeNote);
    if ('orderDiscount' in $$props) $$invalidate(11, orderDiscount = $$props.orderDiscount);
    if ('recurringDiscount' in $$props) $$invalidate(12, recurringDiscount = $$props.recurringDiscount);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*sellingPlanGroups*/256) {
      $: $$invalidate(6, planOptions = (sellingPlanGroups || []).flatMap(group => (group.selling_plans || []).map(plan => ({
        id: String(plan.id),
        name: plan.name
      }))));
    }
    if ($$self.$$.dirty & /*subscribeLabel, orderDiscount, recurringDiscount*/7168) {
      $: $$invalidate(7, subscribeText = (subscribeLabel || DEFAULT_SUBSCRIBE_LABEL).replace(/\{discount\}/g, orderDiscount ?? "").replace(/\{recurring\}/g, recurringDiscount ?? "").
      // Drop a dangling "+ save %" when no discount is configured
      replace(/\s*\+\s*save\s*%/i, "").trim());
    }
    if ($$self.$$.dirty & /*defaultPlan, planOptions*/576) {
      $: $$invalidate(13, initialValue = defaultPlan === "one_time" || !planOptions.length ? ONE_TIME : planOptions[0].id);
    }
    if ($$self.$$.dirty & /*selected, planOptions, initialValue*/8288) {
      $: if (selected === null && planOptions.length) {
        $$invalidate(5, selected = initialValue);
      }
    }
    if ($$self.$$.dirty & /*selected*/32) {
      $: applySelection(selected), selected;
    }
  };
  return [wrapperClass, label, oneTimeLabel, showOneTime, subscribeNote, selected, planOptions, subscribeText, sellingPlanGroups, defaultPlan, subscribeLabel, orderDiscount, recurringDiscount, initialValue, input_change_handler, $$binding_groups, input_change_handler_1];
}
class Plan_radio_selector extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      sellingPlanGroups: 8,
      wrapperClass: 0,
      label: 1,
      oneTimeLabel: 2,
      showOneTime: 3,
      defaultPlan: 9,
      subscribeLabel: 10,
      subscribeNote: 4,
      orderDiscount: 11,
      recurringDiscount: 12
    });
  }
  get sellingPlanGroups() {
    return this.$$.ctx[8];
  }
  set sellingPlanGroups(sellingPlanGroups) {
    this.$$set({
      sellingPlanGroups
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get wrapperClass() {
    return this.$$.ctx[0];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get label() {
    return this.$$.ctx[1];
  }
  set label(label) {
    this.$$set({
      label
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get oneTimeLabel() {
    return this.$$.ctx[2];
  }
  set oneTimeLabel(oneTimeLabel) {
    this.$$set({
      oneTimeLabel
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get showOneTime() {
    return this.$$.ctx[3];
  }
  set showOneTime(showOneTime) {
    this.$$set({
      showOneTime
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get defaultPlan() {
    return this.$$.ctx[9];
  }
  set defaultPlan(defaultPlan) {
    this.$$set({
      defaultPlan
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get subscribeLabel() {
    return this.$$.ctx[10];
  }
  set subscribeLabel(subscribeLabel) {
    this.$$set({
      subscribeLabel
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get subscribeNote() {
    return this.$$.ctx[4];
  }
  set subscribeNote(subscribeNote) {
    this.$$set({
      subscribeNote
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get orderDiscount() {
    return this.$$.ctx[11];
  }
  set orderDiscount(orderDiscount) {
    this.$$set({
      orderDiscount
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get recurringDiscount() {
    return this.$$.ctx[12];
  }
  set recurringDiscount(recurringDiscount) {
    this.$$set({
      recurringDiscount
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Plan_radio_selector, {
  "sellingPlanGroups": {},
  "wrapperClass": {},
  "label": {},
  "oneTimeLabel": {},
  "showOneTime": {
    "type": "Boolean"
  },
  "defaultPlan": {},
  "subscribeLabel": {},
  "subscribeNote": {},
  "orderDiscount": {},
  "recurringDiscount": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Plan_radio_selector);

/***/ }),

/***/ "./js/components/landing-page-buy-box/price-format.js":
/*!************************************************************!*\
  !*** ./js/components/landing-page-buy-box/price-format.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoneyString: () => (/* binding */ formatMoneyString),
/* harmony export */   formatPrice: () => (/* binding */ formatPrice)
/* harmony export */ });
// Money formatting for the buy box. Sections can drop the decimal part
// ("$119.99" -> "$119") without touching the data coming out of Liquid.
// The cents are cut, never rounded — $119.99 must not read as $120.
const currency = () => window.storeCurrency || 'USD';
const locale = () => window.storeLocale || 'en-US';
const toAmount = value => typeof value === 'number' ? value : parseFloat(String(value ?? '').replace(/[^0-9.-]/g, ''));

// value: number or numeric string (no currency symbol required)
const formatPrice = (value, hideDecimals = false) => {
  const amount = toAmount(value);
  if (!isFinite(amount)) return '';
  if (!hideDecimals) {
    return new Intl.NumberFormat(locale(), {
      style: 'currency',
      currency: currency()
    }).format(amount);
  }

  // Truncate toward zero so the whole-dollar part is what the shopper paid
  return new Intl.NumberFormat(locale(), {
    style: 'currency',
    currency: currency(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Math.trunc(amount));
};

// money: already-formatted string from Liquid, e.g. "$119.99".
// Returns it untouched unless decimals are being hidden.
const formatMoneyString = (money, hideDecimals = false) => {
  if (!hideDecimals) return money;
  const formatted = formatPrice(money, true);
  return formatted || money;
};

/***/ }),

/***/ "./js/components/landing-page-buy-box/star-reviews.svelte":
/*!****************************************************************!*\
  !*** ./js/components/landing-page-buy-box/star-reviews.svelte ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! svelte */ "./node_modules/svelte/src/runtime/index.js");
/* harmony import */ var JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/scroll-on-click */ "./js/components/scroll-on-click.js");
/* js/components/landing-page-buy-box/star-reviews.svelte generated by Svelte v4.2.19 */




function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[5] = list[i];
  return child_ctx;
}

// (52:2) {#if reviewData}
function create_if_block(ctx) {
  let div0;
  let t0;
  let div1;
  let t1_value = parseFloat(/*reviewData*/ctx[0].averageScore).toFixed(1) + "";
  let t1;
  let t2;
  let t3;
  let div2;
  let t4_value = /*reviewData*/ctx[0].totalReview + "";
  let t4;
  let t5;
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)([1, 2, 3, 4, 5]);
  let each_blocks = [];
  for (let i = 0; i < 5; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  return {
    c() {
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      for (let i = 0; i < 5; i += 1) {
        each_blocks[i].c();
      }
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" / 5");
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t4_value);
      t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" REVIEWS");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", "landing-page-buy-box__reviews-stars landing-page-buy-box__review-item");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", "review__average landing-page-buy-box__review-item");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", "review__count landing-page-buy-box__review-item");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div0, anchor);
      for (let i = 0; i < 5; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div0, null);
        }
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t0, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t3, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div2, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t4);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t5);
    },
    p(ctx, dirty) {
      if (dirty & /*filledStarIcon, Math, reviewData, halfFilledStarIcon, unfilledStarIcon*/15) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)([1, 2, 3, 4, 5]);
        let i;
        for (i = 0; i < 5; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(div0, null);
          }
        }
        for (; i < 5; i += 1) {
          each_blocks[i].d(1);
        }
      }
      if (dirty & /*reviewData*/1 && t1_value !== (t1_value = parseFloat(/*reviewData*/ctx[0].averageScore).toFixed(1) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, t1_value);
      if (dirty & /*reviewData*/1 && t4_value !== (t4_value = /*reviewData*/ctx[0].totalReview + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t4, t4_value);
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div0);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t0);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t3);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div2);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
    }
  };
}

// (60:10) {:else}
function create_else_block(ctx) {
  let html_tag;
  let html_anchor;
  return {
    c() {
      html_tag = new svelte_internal__WEBPACK_IMPORTED_MODULE_0__.HtmlTag(false);
      html_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
      html_tag.a = html_anchor;
    },
    m(target, anchor) {
      html_tag.m(/*unfilledStarIcon*/ctx[3], target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, html_anchor, anchor);
    },
    p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(html_anchor);
        html_tag.d();
      }
    }
  };
}

// (58:102) 
function create_if_block_2(ctx) {
  let html_tag;
  let html_anchor;
  return {
    c() {
      html_tag = new svelte_internal__WEBPACK_IMPORTED_MODULE_0__.HtmlTag(false);
      html_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
      html_tag.a = html_anchor;
    },
    m(target, anchor) {
      html_tag.m(/*halfFilledStarIcon*/ctx[2], target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, html_anchor, anchor);
    },
    p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(html_anchor);
        html_tag.d();
      }
    }
  };
}

// (56:10) {#if star <= Math.floor(reviewData.averageScore)}
function create_if_block_1(ctx) {
  let html_tag;
  let html_anchor;
  return {
    c() {
      html_tag = new svelte_internal__WEBPACK_IMPORTED_MODULE_0__.HtmlTag(false);
      html_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
      html_tag.a = html_anchor;
    },
    m(target, anchor) {
      html_tag.m(/*filledStarIcon*/ctx[1], target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, html_anchor, anchor);
    },
    p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(html_anchor);
        html_tag.d();
      }
    }
  };
}

// (54:6) {#each [1, 2, 3, 4, 5] as star}
function create_each_block(ctx) {
  let div;
  let show_if;
  let show_if_1;
  let t;
  function select_block_type(ctx, dirty) {
    if (dirty & /*reviewData*/1) show_if = null;
    if (dirty & /*reviewData*/1) show_if_1 = null;
    if (show_if == null) show_if = !!(/*star*/ctx[5] <= Math.floor(/*reviewData*/ctx[0].averageScore));
    if (show_if) return create_if_block_1;
    if (show_if_1 == null) show_if_1 = !!(/*star*/ctx[5] === Math.ceil(/*reviewData*/ctx[0].averageScore) && /*reviewData*/ctx[0].averageScore % 1 >= 0.5);
    if (show_if_1) return create_if_block_2;
    return create_else_block;
  }
  let current_block_type = select_block_type(ctx, -1);
  let if_block = current_block_type(ctx);
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      if_block.c();
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "landing-page-buy-box__review-star");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      if_block.m(div, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t);
    },
    p(ctx, dirty) {
      if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
        if_block.p(ctx, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx);
        if (if_block) {
          if_block.c();
          if_block.m(div, t);
        }
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      if_block.d();
    }
  };
}
function create_fragment(ctx) {
  let div;
  let if_block = /*reviewData*/ctx[0] && create_if_block(ctx);
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      if (if_block) if_block.c();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "landing-page-buy-box__reviews review");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      if (if_block) if_block.m(div, null);
    },
    p(ctx, [dirty]) {
      if (/*reviewData*/ctx[0]) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block(ctx);
          if_block.c();
          if_block.m(div, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
      if (if_block) if_block.d();
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let {
    shopifyData
  } = $$props;
  let reviewData = false;
  (0,svelte__WEBPACK_IMPORTED_MODULE_2__.onMount)(() => {
    // Defer so other sections (synchro-reviews, product CTA, buy box DOM) are in the document
    const run = () => {
      (0,JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__.scrollOnClick)('.landing-page-buy-box__reviews', '.wrapper.section-padding', 100);

      // Match actual classes: landing-page-buy-box__product-buy-button, gold-purchase__product-buy-button (exclude product-buy-button-mian)
      // scrollOnClick('[class*="product-buy-button-mian"]', '.landing-page-buy-box.landing-page-buy-box--alternate', 80);
      (0,JsComponents_scroll_on_click__WEBPACK_IMPORTED_MODULE_3__.scrollOnClick)('.product-buy-button-mian', '.landing-page-buy-box--alternate', 100);
    };
    requestAnimationFrame(() => requestAnimationFrame(run));
  });
  const filledStarIcon = `<svg width="10" height="10" class="{{ class }}" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.05544 0.717389C4.36673 -0.178171 5.63327 -0.178172 5.94456 0.717388L6.41733 2.07747C6.55465 2.47254 6.92334 2.74041 7.34152 2.74893L8.78112 2.77827C9.72905 2.79758 10.1204 4.00213 9.36489 4.57493L8.21747 5.44485C7.88417 5.69753 7.74335 6.13096 7.86446 6.53129L8.28142 7.9095C8.55598 8.817 7.53133 9.56145 6.75309 9.01991L5.57118 8.19746C5.22786 7.95856 4.77214 7.95856 4.42882 8.19746L3.24691 9.01991C2.46867 9.56145 1.44402 8.817 1.71858 7.90951L2.13554 6.53129C2.25665 6.13096 2.11583 5.69753 1.78253 5.44485L0.635109 4.57493C-0.120424 4.00213 0.270956 2.79758 1.21888 2.77827L2.65848 2.74893C3.07665 2.74041 3.44535 2.47254 3.58267 2.07747L4.05544 0.717389Z" fill="#231F20"/>
  </svg> `;

  // Use CSS clip-path so no SVG id is needed (avoids url(#id) mismatch / duplicate-id issues)
  const halfFilledStarIcon = `<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.25" d="M4.05544 0.717389C4.36673 -0.178171 5.63327 -0.178172 5.94456 0.717388L6.41733 2.07747C6.55465 2.47254 6.92334 2.74041 7.34152 2.74893L8.78112 2.77827C9.72905 2.79758 10.1204 4.00213 9.36489 4.57493L8.21747 5.44485C7.88417 5.69753 7.74335 6.13096 7.86446 6.53129L8.28142 7.9095C8.55598 8.817 7.53133 9.56145 6.75309 9.01991L5.57118 8.19746C5.22786 7.95856 4.77214 7.95856 4.42882 8.19746L3.24691 9.01991C2.46867 9.56145 1.44402 8.817 1.71858 7.90951L2.13554 6.53129C2.25665 6.13096 2.11583 5.69753 1.78253 5.44485L0.635109 4.57493C-0.120424 4.00213 0.270956 2.79758 1.21888 2.77827L2.65848 2.74893C3.07665 2.74041 3.44535 2.47254 3.58267 2.07747L4.05544 0.717389Z" fill="#231F20"/>
    <path style="clip-path: inset(0 50% 0 0);" d="M4.05544 0.717389C4.36673 -0.178171 5.63327 -0.178172 5.94456 0.717388L6.41733 2.07747C6.55465 2.47254 6.92334 2.74041 7.34152 2.74893L8.78112 2.77827C9.72905 2.79758 10.1204 4.00213 9.36489 4.57493L8.21747 5.44485C7.88417 5.69753 7.74335 6.13096 7.86446 6.53129L8.28142 7.9095C8.55598 8.817 7.53133 9.56145 6.75309 9.01991L5.57118 8.19746C5.22786 7.95856 4.77214 7.95856 4.42882 8.19746L3.24691 9.01991C2.46867 9.56145 1.44402 8.817 1.71858 7.90951L2.13554 6.53129C2.25665 6.13096 2.11583 5.69753 1.78253 5.44485L0.635109 4.57493C-0.120424 4.00213 0.270956 2.79758 1.21888 2.77827L2.65848 2.74893C3.07665 2.74041 3.44535 2.47254 3.58267 2.07747L4.05544 0.717389Z" fill="#231F20"/>
  </svg>`;
  const unfilledStarIcon = `<svg width="10" height="10" class="{{ class }}" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.25" d="M4.05544 0.717389C4.36673 -0.178171 5.63327 -0.178172 5.94456 0.717388L6.41733 2.07747C6.55465 2.47254 6.92334 2.74041 7.34152 2.74893L8.78112 2.77827C9.72905 2.79758 10.1204 4.00213 9.36489 4.57493L8.21747 5.44485C7.88417 5.69753 7.74335 6.13096 7.86446 6.53129L8.28142 7.9095C8.55598 8.817 7.53133 9.56145 6.75309 9.01991L5.57118 8.19746C5.22786 7.95856 4.77214 7.95856 4.42882 8.19746L3.24691 9.01991C2.46867 9.56145 1.44402 8.817 1.71858 7.90951L2.13554 6.53129C2.25665 6.13096 2.11583 5.69753 1.78253 5.44485L0.635109 4.57493C-0.120424 4.00213 0.270956 2.79758 1.21888 2.77827L2.65848 2.74893C3.07665 2.74041 3.44535 2.47254 3.58267 2.07747L4.05544 0.717389Z" fill="#231F20"/>
  </svg>`;
  $$self.$$set = $$props => {
    if ('shopifyData' in $$props) $$invalidate(4, shopifyData = $$props.shopifyData);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*shopifyData, reviewData*/17) {
      // Get review data from metafields - make it reactive
      // shopifyData is the inner "data" object: { productId, reviewsCount, reviewsAverage }
      $: {
        const data = shopifyData || {};
        const reviewsCount = data.reviewsCount;
        const reviewsAverage = data.reviewsAverage;
        const hasCount = reviewsCount !== undefined && reviewsCount !== null && reviewsCount !== '';
        const hasAverage = reviewsAverage !== undefined && reviewsAverage !== null && reviewsAverage !== '';
        if (hasCount || hasAverage) {
          $$invalidate(0, reviewData = {
            totalReview: Number(reviewsCount) || 0,
            averageScore: Number(reviewsAverage) || 0
          });
        } else {
          $$invalidate(0, reviewData = false);
        }
        console.log(reviewData, "-----reviewData");
      }
    }
  };
  return [reviewData, filledStarIcon, halfFilledStarIcon, unfilledStarIcon, shopifyData];
}
class Star_reviews extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      shopifyData: 4
    });
  }
  get shopifyData() {
    return this.$$.ctx[4];
  }
  set shopifyData(shopifyData) {
    this.$$set({
      shopifyData
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Star_reviews, {
  "shopifyData": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Star_reviews);

/***/ }),

/***/ "./js/components/landing-page-buy-box/sticky-buy-box.svelte":
/*!******************************************************************!*\
  !*** ./js/components/landing-page-buy-box/sticky-buy-box.svelte ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/responsive-image.svelte */ "./js/components/responsive-image.svelte");
/* harmony import */ var _price_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./price-format */ "./js/components/landing-page-buy-box/price-format.js");
/* js/components/landing-page-buy-box/sticky-buy-box.svelte generated by Svelte v4.2.19 */





function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  child_ctx[9] = i;
  const constants_0 = parseFloat(/*variant*/child_ctx[6].price.replace(/[^0-9.]/g, '')) < parseFloat(/*variant*/child_ctx[6].compareAtPrice.replace(/[^0-9.]/g, ''));
  child_ctx[7] = constants_0;
  return child_ctx;
}

// (27:6) {:else}
function create_else_block(ctx) {
  let div;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div.textContent = `${/*variant*/ctx[6].name.split('-')[0].split('+')[0].split('·')[0]}`;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "floating-purchase-options__quantity");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
    },
    p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}

// (25:6) {#if flag}
function create_if_block_1(ctx) {
  let div;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div.textContent = `${/*variant*/ctx[6].customVariantText}`;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "floating-purchase-options__quantity");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
    },
    p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}

// (32:8) {#if hasDiscount}
function create_if_block(ctx) {
  let span;
  return {
    c() {
      span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      span.textContent = `${(0,_price_format__WEBPACK_IMPORTED_MODULE_2__.formatMoneyString)(/*variant*/ctx[6].compareAtPrice, /*hidePriceDecimals*/ctx[1])}`;
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, span, anchor);
    },
    p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(span);
      }
    }
  };
}

// (13:0) {#each variants as variant, index }
function create_each_block(ctx) {
  let div3;
  let responsiveimage;
  let t0;
  let div0;
  let t1;
  let div2;
  let t2;
  let div1;
  let t3_value = (0,_price_format__WEBPACK_IMPORTED_MODULE_2__.formatMoneyString)(/*variant*/ctx[6].price, /*hidePriceDecimals*/ctx[1]) + "";
  let t3;
  let t4;
  let t5;
  let a;
  let t6;
  let a_href_value;
  let t7;
  let div3_class_value;
  let div3_data_index_value;
  let current;
  let mounted;
  let dispose;
  responsiveimage = new JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_3__["default"]({
    props: {
      image: /*variant*/ctx[6].image,
      image_aspect_ratio: 1
    }
  });
  function select_block_type(ctx, dirty) {
    if (flag) return create_if_block_1;
    return create_else_block;
  }
  let current_block_type = select_block_type(ctx, -1);
  let if_block0 = current_block_type(ctx);
  let if_block1 = /*hasDiscount*/ctx[7] && create_if_block(ctx);
  function click_handler() {
    return /*click_handler*/ctx[4](/*variant*/ctx[6]);
  }
  return {
    c() {
      div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(responsiveimage.$$.fragment);
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      if_block0.c();
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t3_value);
      t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block1) if_block1.c();
      t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      a = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("a");
      t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Buy Now");
      t7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", "floating-purchase-options__divider");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", "floating-purchase-options__price");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", "floating-purchase-options__details");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(a, "class", "a--cta");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(a, "href", a_href_value = `/cart/${/*variant*/ctx[6].id}:1`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value = "floating-purchase-options__item floating-purchase-options__item" + /*index*/ctx[9] + " " + (/*hasDiscount*/ctx[7] ? '' : 'floating-purchase-options__item-small-container'));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "data-index", div3_data_index_value = /*index*/ctx[9]);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div3, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(responsiveimage, div3, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div2);
      if_block0.m(div2, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, div1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t3);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t4);
      if (if_block1) if_block1.m(div1, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t5);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, a);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(a, t6);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t7);
      current = true;
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(div3, "click", click_handler);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      if_block0.p(ctx, dirty);
      if (/*hasDiscount*/ctx[7]) if_block1.p(ctx, dirty);
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(responsiveimage.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(responsiveimage.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div3);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(responsiveimage);
      if_block0.d();
      if (if_block1) if_block1.d();
      mounted = false;
      dispose();
    }
  };
}
function create_fragment(ctx) {
  let each_1_anchor;
  let current;
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ctx[0]);
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  const out = i => (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
    },
    m(target, anchor) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(target, anchor);
        }
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, each_1_anchor, anchor);
      current = true;
    },
    p(ctx, [dirty]) {
      if (dirty & /*parseFloat, variants, window, hidePriceDecimals, flag*/3) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ctx[0]);
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
            each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
      }
    },
    i(local) {
      if (current) return;
      for (let i = 0; i < each_value.length; i += 1) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(each_1_anchor);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
    }
  };
}
const flag = true; //set true, to display custom variant name(metafield)

function instance($$self, $$props, $$invalidate) {
  let $selectedVariant;
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_4__.selectedVariant, $$value => $$invalidate(3, $selectedVariant = $$value));
  let {
    shopifyData
  } = $$props;
  const {
    variants,
    settings
  } = shopifyData || {};

  // Section option: drop the cents from displayed prices
  const hidePriceDecimals = settings?.hidePriceDecimals === true;
  const click_handler = variant => window.location.href = `/cart/${variant.id}:1`;
  $$self.$$set = $$props => {
    if ('shopifyData' in $$props) $$invalidate(2, shopifyData = $$props.shopifyData);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$selectedVariant*/8) {
      $: console.log($selectedVariant);
    }
  };
  return [variants, hidePriceDecimals, shopifyData, $selectedVariant, click_handler];
}
class Sticky_buy_box extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      shopifyData: 2
    });
  }
  get shopifyData() {
    return this.$$.ctx[2];
  }
  set shopifyData(shopifyData) {
    this.$$set({
      shopifyData
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Sticky_buy_box, {
  "shopifyData": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Sticky_buy_box);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-cards-selector.svelte":
/*!**************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-cards-selector.svelte ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/responsive-image.svelte */ "./js/components/responsive-image.svelte");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var _price_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./price-format */ "./js/components/landing-page-buy-box/price-format.js");
/* js/components/landing-page-buy-box/variant-cards-selector.svelte generated by Svelte v4.2.19 */





function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[8] = list[i];
  child_ctx[15] = i;
  const constants_0 = /*variant*/child_ctx[8].name.split("-");
  child_ctx[9] = constants_0;
  const constants_1 = /*variant*/child_ctx[8].customVariantText || /*splitName*/child_ctx[9][0];
  child_ctx[10] = constants_1;
  const constants_2 = /*splitName*/child_ctx[9][1] ? /*splitName*/child_ctx[9][1].trim() : "";
  child_ctx[11] = constants_2;
  const constants_3 = /*$selectedVariant*/child_ctx[5][/*productId*/child_ctx[3]]?.id == /*variant*/child_ctx[8].id;
  child_ctx[12] = constants_3;
  const constants_4 = /*customImages*/child_ctx[6][/*index*/child_ctx[15]] || "";
  child_ctx[13] = constants_4;
  return child_ctx;
}

// (33:34) 
function create_if_block_2(ctx) {
  let responsiveimage;
  let current;
  responsiveimage = new JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
    props: {
      image: /*variant*/ctx[8].image,
      image_aspect_ratio: "1",
      objectFit: "contain",
      maxHeight: "78"
    }
  });
  return {
    c() {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(responsiveimage.$$.fragment);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(responsiveimage, target, anchor);
      current = true;
    },
    p(ctx, dirty) {
      const responsiveimage_changes = {};
      if (dirty & /*variants*/1) responsiveimage_changes.image = /*variant*/ctx[8].image;
      responsiveimage.$set(responsiveimage_changes);
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(responsiveimage.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(responsiveimage.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(responsiveimage, detaching);
    }
  };
}

// (31:10) {#if customImageUrl}
function create_if_block_1(ctx) {
  let img;
  let img_src_value;
  let img_alt_value;
  return {
    c() {
      img = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("img");
      if (!(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.src_url_equal)(img.src, img_src_value = /*customImageUrl*/ctx[13])) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "src", img_src_value);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "alt", img_alt_value = /*variantName*/ctx[10]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "width", "78");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "height", "78");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "loading", "lazy");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, img, anchor);
    },
    p(ctx, dirty) {
      if (dirty & /*variants*/1 && img_alt_value !== (img_alt_value = /*variantName*/ctx[10])) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "alt", img_alt_value);
      }
    },
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(img);
      }
    }
  };
}

// (47:25) {#if supplyInfo}
function create_if_block(ctx) {
  let t0;
  let t1_value = /*supplyInfo*/ctx[11] + "";
  let t1;
  let t2;
  return {
    c() {
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("(");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(")");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t0, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t2, anchor);
    },
    p(ctx, dirty) {
      if (dirty & /*variants*/1 && t1_value !== (t1_value = /*supplyInfo*/ctx[11] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, t1_value);
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t0);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t1);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t2);
      }
    }
  };
}

// (17:4) {#each variants as variant, index}
function create_each_block(ctx) {
  let div3;
  let div0;
  let current_block_type_index;
  let if_block0;
  let div0_class_value;
  let t0;
  let div1;
  let t1_value = /*variantName*/ctx[10] + "";
  let t1;
  let div1_class_value;
  let t2;
  let div2;
  let span0;
  let t3_value = /*variantName*/ctx[10] + "";
  let t3;
  let span0_class_value;
  let t4;
  let span1;
  let t5_value = (0,_price_format__WEBPACK_IMPORTED_MODULE_3__.formatMoneyString)(/*variant*/ctx[8].price, /*settings*/ctx[4]?.hidePriceDecimals) + "";
  let t5;
  let span1_class_value;
  let div2_class_value;
  let t6;
  let div3_class_value;
  let current;
  let mounted;
  let dispose;
  const if_block_creators = [create_if_block_1, create_if_block_2];
  const if_blocks = [];
  function select_block_type(ctx, dirty) {
    if (/*customImageUrl*/ctx[13]) return 0;
    if (/*variant*/ctx[8].image) return 1;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx, -1))) {
    if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  let if_block1 = /*supplyInfo*/ctx[11] && create_if_block(ctx);
  function click_handler() {
    return /*click_handler*/ctx[7](/*variant*/ctx[8]);
  }
  return {
    c() {
      div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      if (if_block0) if_block0.c();
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t3_value);
      if (if_block1) if_block1.c();
      t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
      t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t5_value);
      t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-image"));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-name--desktop"));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span0, "class", span0_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-name--mobile"));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span1, "class", span1_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-price"));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-mobile-row"));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card " + (/*isSelected*/ctx[12] ? 'selected' : '')));
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div3, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div0);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(div0, null);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, span0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span0, t3);
      if (if_block1) if_block1.m(span0, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t4);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, span1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(span1, t5);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t6);
      current = true;
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(div3, "click", click_handler);
        mounted = true;
      }
    },
    p(new_ctx, dirty) {
      ctx = new_ctx;
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx, dirty);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx, dirty);
        }
      } else {
        if (if_block0) {
          (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();
          (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_blocks[previous_block_index], 1, 1, () => {
            if_blocks[previous_block_index] = null;
          });
          (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
        }
        if (~current_block_type_index) {
          if_block0 = if_blocks[current_block_type_index];
          if (!if_block0) {
            if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
            if_block0.c();
          } else {
            if_block0.p(ctx, dirty);
          }
          (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block0, 1);
          if_block0.m(div0, null);
        } else {
          if_block0 = null;
        }
      }
      if (!current || dirty & /*wrapperClass*/4 && div0_class_value !== (div0_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-image"))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if ((!current || dirty & /*variants*/1) && t1_value !== (t1_value = /*variantName*/ctx[10] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t1, t1_value);
      if (!current || dirty & /*wrapperClass*/4 && div1_class_value !== (div1_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-name--desktop"))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
      if ((!current || dirty & /*variants*/1) && t3_value !== (t3_value = /*variantName*/ctx[10] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t3, t3_value);
      if (/*supplyInfo*/ctx[11]) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
        } else {
          if_block1 = create_if_block(ctx);
          if_block1.c();
          if_block1.m(span0, null);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (!current || dirty & /*wrapperClass*/4 && span0_class_value !== (span0_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-name--mobile"))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span0, "class", span0_class_value);
      }
      if ((!current || dirty & /*variants, settings*/17) && t5_value !== (t5_value = (0,_price_format__WEBPACK_IMPORTED_MODULE_3__.formatMoneyString)(/*variant*/ctx[8].price, /*settings*/ctx[4]?.hidePriceDecimals) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t5, t5_value);
      if (!current || dirty & /*wrapperClass*/4 && span1_class_value !== (span1_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-price"))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(span1, "class", span1_class_value);
      }
      if (!current || dirty & /*wrapperClass*/4 && div2_class_value !== (div2_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card-mobile-row"))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value);
      }
      if (!current || dirty & /*wrapperClass, $selectedVariant, productId, variants*/45 && div3_class_value !== (div3_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-card " + (/*isSelected*/ctx[12] ? 'selected' : '')))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value);
      }
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block0);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_block0);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div3);
      }
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
      if (if_block1) if_block1.d();
      mounted = false;
      dispose();
    }
  };
}
function create_fragment(ctx) {
  let div2;
  let div0;
  let t0;
  let div0_class_value;
  let t1;
  let div1;
  let div1_class_value;
  let div2_class_value;
  let current;
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ctx[0]);
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  const out = i => (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Select Size");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-cards-label"));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-cards " + /*wrapperClass*/ctx[2] + "__variant-cards--" + /*variants*/ctx[0].length + "-variants"));
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value = "" + (/*wrapperClass*/ctx[2] + "__product-info-row " + /*wrapperClass*/ctx[2] + "__variant-cards-selector"));
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div2, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, div0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, div1);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(div1, null);
        }
      }
      current = true;
    },
    p(ctx, [dirty]) {
      if (!current || dirty & /*wrapperClass*/4 && div0_class_value !== (div0_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-cards-label"))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (dirty & /*wrapperClass, $selectedVariant, productId, variants, callback, settings, customImages*/127) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ctx[0]);
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
            each_blocks[i].m(div1, null);
          }
        }
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
      }
      if (!current || dirty & /*wrapperClass, variants*/5 && div1_class_value !== (div1_class_value = "" + (/*wrapperClass*/ctx[2] + "__variant-cards " + /*wrapperClass*/ctx[2] + "__variant-cards--" + /*variants*/ctx[0].length + "-variants"))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
      if (!current || dirty & /*wrapperClass*/4 && div2_class_value !== (div2_class_value = "" + (/*wrapperClass*/ctx[2] + "__product-info-row " + /*wrapperClass*/ctx[2] + "__variant-cards-selector"))) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value);
      }
    },
    i(local) {
      if (current) return;
      for (let i = 0; i < each_value.length; i += 1) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div2);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let $selectedVariant;
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_4__.selectedVariant, $$value => $$invalidate(5, $selectedVariant = $$value));
  let {
    variants
  } = $$props;
  let {
    callback
  } = $$props;
  let {
    wrapperClass
  } = $$props;
  let {
    productId
  } = $$props;
  let {
    settings = {}
  } = $$props;
  const customImages = settings?.variantCardImages || [];
  const click_handler = variant => callback(variant.id);
  $$self.$$set = $$props => {
    if ('variants' in $$props) $$invalidate(0, variants = $$props.variants);
    if ('callback' in $$props) $$invalidate(1, callback = $$props.callback);
    if ('wrapperClass' in $$props) $$invalidate(2, wrapperClass = $$props.wrapperClass);
    if ('productId' in $$props) $$invalidate(3, productId = $$props.productId);
    if ('settings' in $$props) $$invalidate(4, settings = $$props.settings);
  };
  return [variants, callback, wrapperClass, productId, settings, $selectedVariant, customImages, click_handler];
}
class Variant_cards_selector extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      variants: 0,
      callback: 1,
      wrapperClass: 2,
      productId: 3,
      settings: 4
    });
  }
  get variants() {
    return this.$$.ctx[0];
  }
  set variants(variants) {
    this.$$set({
      variants
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get callback() {
    return this.$$.ctx[1];
  }
  set callback(callback) {
    this.$$set({
      callback
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get wrapperClass() {
    return this.$$.ctx[2];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get productId() {
    return this.$$.ctx[3];
  }
  set productId(productId) {
    this.$$set({
      productId
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get settings() {
    return this.$$.ctx[4];
  }
  set settings(settings) {
    this.$$set({
      settings
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_cards_selector, {
  "variants": {},
  "callback": {},
  "wrapperClass": {},
  "productId": {},
  "settings": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_cards_selector);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-description-minimal.svelte":
/*!*******************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-description-minimal.svelte ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var _price_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./price-format */ "./js/components/landing-page-buy-box/price-format.js");
/* js/components/landing-page-buy-box/variant-description-minimal.svelte generated by Svelte v4.2.19 */




function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[29] = list[i];
  return child_ctx;
}

// (118:2) {#if calculatedCompareAtPrice && calculatedCompareAtPrice != displayPrice}
function create_if_block_2(ctx) {
  let div;
  let t_value = (0,_price_format__WEBPACK_IMPORTED_MODULE_2__.formatMoneyString)(/*calculatedCompareAtPrice*/ctx[6], /*hidePriceDecimals*/ctx[4]) + "";
  let t;
  let div_class_value;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__compare-price ${/*wrapperClass*/ctx[0]}__price-box-item`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*calculatedCompareAtPrice, hidePriceDecimals*/80 && t_value !== (t_value = (0,_price_format__WEBPACK_IMPORTED_MODULE_2__.formatMoneyString)(/*calculatedCompareAtPrice*/ctx[6], /*hidePriceDecimals*/ctx[4]) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, t_value);
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__compare-price ${/*wrapperClass*/ctx[0]}__price-box-item`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}

// (129:40) 
function create_if_block_1(ctx) {
  let div;
  let t;
  let div_class_value;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*supplyText*/ctx[7]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__supply-info`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*supplyText*/128) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, /*supplyText*/ctx[7]);
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__supply-info`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}

// (125:1) {#if subscriptionOnly}
function create_if_block(ctx) {
  let each_1_anchor;
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)((/*subscriptionNoteLines*/ctx[3] || []).filter(Boolean));
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  return {
    c() {
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
    },
    m(target, anchor) {
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(target, anchor);
        }
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, each_1_anchor, anchor);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*wrapperClass, subscriptionNoteLines*/9) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)((/*subscriptionNoteLines*/ctx[3] || []).filter(Boolean));
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(each_1_anchor);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
    }
  };
}

// (126:2) {#each (subscriptionNoteLines || []).filter(Boolean) as line}
function create_each_block(ctx) {
  let div;
  let t_value = /*line*/ctx[29] + "";
  let t;
  let div_class_value;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__subscription-note`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*subscriptionNoteLines*/8 && t_value !== (t_value = /*line*/ctx[29] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, t_value);
      if (dirty[0] & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__subscription-note`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}
function create_fragment(ctx) {
  let div2;
  let div1;
  let div0;
  let t0;
  let div0_class_value;
  let t1;
  let div1_class_value;
  let t2;
  let div2_class_value;
  let if_block0 = /*calculatedCompareAtPrice*/ctx[6] && /*calculatedCompareAtPrice*/ctx[6] != /*displayPrice*/ctx[5] && create_if_block_2(ctx);
  function select_block_type(ctx, dirty) {
    if (/*subscriptionOnly*/ctx[2]) return create_if_block;
    if (/*supplyText*/ctx[7] && /*showSupplyText*/ctx[1]) return create_if_block_1;
  }
  let current_block_type = select_block_type(ctx, [-1, -1]);
  let if_block1 = current_block_type && current_block_type(ctx);
  return {
    c() {
      div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*displayPrice*/ctx[5]);
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block0) if_block0.c();
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      if (if_block1) if_block1.c();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ctx[0]}__selling-price ${/*wrapperClass*/ctx[0]}__price-box-item`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ctx[0]}__price-box`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value = `${/*wrapperClass*/ctx[0]}__description`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div2, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, div1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, div0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t1);
      if (if_block0) if_block0.m(div1, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t2);
      if (if_block1) if_block1.m(div2, null);
    },
    p(ctx, dirty) {
      if (dirty[0] & /*displayPrice*/32) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t0, /*displayPrice*/ctx[5]);
      if (dirty[0] & /*wrapperClass*/1 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ctx[0]}__selling-price ${/*wrapperClass*/ctx[0]}__price-box-item`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (/*calculatedCompareAtPrice*/ctx[6] && /*calculatedCompareAtPrice*/ctx[6] != /*displayPrice*/ctx[5]) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
        } else {
          if_block0 = create_if_block_2(ctx);
          if_block0.c();
          if_block0.m(div1, null);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (dirty[0] & /*wrapperClass*/1 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ctx[0]}__price-box`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
      if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block1) {
        if_block1.p(ctx, dirty);
      } else {
        if (if_block1) if_block1.d(1);
        if_block1 = current_block_type && current_block_type(ctx);
        if (if_block1) {
          if_block1.c();
          if_block1.m(div2, null);
        }
      }
      if (dirty[0] & /*wrapperClass*/1 && div2_class_value !== (div2_class_value = `${/*wrapperClass*/ctx[0]}__description`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value);
      }
    },
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div2);
      }
      if (if_block0) if_block0.d();
      if (if_block1) {
        if_block1.d();
      }
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let subscriptionsEnabled;
  let selectedVariantData;
  let price;
  let compareAtPrice;
  let discount;
  let priceWithoutCurrency;
  let displayPriceRaw;
  let displayPrice;
  let calculatedCompareAtPrice;
  let calculatedDiscount;
  let splitName;
  let variantName;
  let supplyInterval;
  let servingCount;
  let supplyText;
  let $selectedSellingPlanStore;
  let $selectedVariant;
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedSellingPlanStore, $$value => $$invalidate(25, $selectedSellingPlanStore = $$value));
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_3__.selectedVariant, $$value => $$invalidate(26, $selectedVariant = $$value));
  let {
    wrapperClass
  } = $$props;
  let {
    variantSelectorType
  } = $$props;
  let {
    productId
  } = $$props;
  let {
    finalDiscountedPrice
  } = $$props;
  let {
    showSubscription
  } = $$props;
  let {
    discountBgColor
  } = $$props;
  let {
    dropdownContent = 'variants'
  } = $$props;
  let {
    showSupplyText = true
  } = $$props;
  let {
    supplyTextOverride = ''
  } = $$props;
  let {
    subscriptionOnly = false
  } = $$props;
  let {
    subscriptionNoteLines = []
  } = $$props;
  let {
    hidePriceDecimals = false
  } = $$props;
  $$self.$$set = $$props => {
    if ('wrapperClass' in $$props) $$invalidate(0, wrapperClass = $$props.wrapperClass);
    if ('variantSelectorType' in $$props) $$invalidate(8, variantSelectorType = $$props.variantSelectorType);
    if ('productId' in $$props) $$invalidate(9, productId = $$props.productId);
    if ('finalDiscountedPrice' in $$props) $$invalidate(10, finalDiscountedPrice = $$props.finalDiscountedPrice);
    if ('showSubscription' in $$props) $$invalidate(11, showSubscription = $$props.showSubscription);
    if ('discountBgColor' in $$props) $$invalidate(12, discountBgColor = $$props.discountBgColor);
    if ('dropdownContent' in $$props) $$invalidate(13, dropdownContent = $$props.dropdownContent);
    if ('showSupplyText' in $$props) $$invalidate(1, showSupplyText = $$props.showSupplyText);
    if ('supplyTextOverride' in $$props) $$invalidate(14, supplyTextOverride = $$props.supplyTextOverride);
    if ('subscriptionOnly' in $$props) $$invalidate(2, subscriptionOnly = $$props.subscriptionOnly);
    if ('subscriptionNoteLines' in $$props) $$invalidate(3, subscriptionNoteLines = $$props.subscriptionNoteLines);
    if ('hidePriceDecimals' in $$props) $$invalidate(4, hidePriceDecimals = $$props.hidePriceDecimals);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty[0] & /*subscriptionOnly, showSubscription, dropdownContent*/10244) {
      // The plan dropdown implies subscriptions are in play even when the
      // radio-based subscription block is switched off.
      $: $$invalidate(22, subscriptionsEnabled = subscriptionOnly || showSubscription || dropdownContent === 'selling_plans');
    }
    if ($$self.$$.dirty[0] & /*$selectedVariant, productId*/67109376) {
      $: $$invalidate(19, selectedVariantData = $selectedVariant[productId]);
    }
    if ($$self.$$.dirty[0] & /*selectedVariantData*/524288) {
      $: $$invalidate(21, {
        price,
        compareAtPrice = false,
        discount,
        priceWithoutCurrency
      } = selectedVariantData || {}, discount, ($$invalidate(24, priceWithoutCurrency), $$invalidate(19, selectedVariantData), $$invalidate(26, $selectedVariant), $$invalidate(9, productId)));
    }
    if ($$self.$$.dirty[0] & /*subscriptionsEnabled, priceWithoutCurrency, $selectedSellingPlanStore, finalDiscountedPrice*/54526976) {
      // When showSubscription is false, always use regular price (ignore manual discount calculations)
      // When showSubscription is true, use subscription price if selected, otherwise regular price
      $: $$invalidate(23, displayPriceRaw = (() => {
        if (!subscriptionsEnabled) {
          // Always use regular price when subscriptions are hidden
          return priceWithoutCurrency;
        } else if ($selectedSellingPlanStore && finalDiscountedPrice && !isNaN(parseFloat(finalDiscountedPrice))) {
          // Use subscription price when subscriptions are shown and selected
          return parseFloat(finalDiscountedPrice);
        } else {
          // Use regular price when subscriptions are shown but not selected
          return priceWithoutCurrency;
        }
      })());
    }
    if ($$self.$$.dirty[0] & /*displayPriceRaw, hidePriceDecimals*/8388624) {
      $: $$invalidate(5, displayPrice = (0,_price_format__WEBPACK_IMPORTED_MODULE_2__.formatPrice)(displayPriceRaw, hidePriceDecimals));
    }
    if ($$self.$$.dirty[0] & /*subscriptionsEnabled, selectedVariantData, $selectedSellingPlanStore, finalDiscountedPrice*/38274048) {
      // Calculate compareAtPrice based on displayPrice when subscription is selected
      $: $$invalidate(6, calculatedCompareAtPrice = (() => {
        if (!subscriptionsEnabled) {
          // Always use regular compareAtPrice when subscriptions are hidden
          return selectedVariantData?.compareAtPrice;
        } else if ($selectedSellingPlanStore && finalDiscountedPrice && !isNaN(parseFloat(finalDiscountedPrice))) {
          // Use subscription compareAtPrice when subscriptions are shown and selected
          return selectedVariantData?.compareAtPrice || selectedVariantData?.price;
        } else {
          // Use regular compareAtPrice when subscriptions are shown but not selected
          return selectedVariantData?.compareAtPrice;
        }
      })());
    }
    if ($$self.$$.dirty[0] & /*subscriptionsEnabled, discount, $selectedSellingPlanStore, finalDiscountedPrice, calculatedCompareAtPrice*/39846976) {
      // Calculate discount percentage based on subscription selection
      $: $$invalidate(15, calculatedDiscount = (() => {
        if (!subscriptionsEnabled) {
          // Always use regular discount when subscriptions are hidden
          return discount;
        } else if ($selectedSellingPlanStore && finalDiscountedPrice && !isNaN(parseFloat(finalDiscountedPrice)) && calculatedCompareAtPrice) {
          // Use subscription discount calculation when subscriptions are shown and selected
          return Math.round((parseFloat(calculatedCompareAtPrice.replace(/[^0-9.]/g, '')) - parseFloat(finalDiscountedPrice)) / parseFloat(calculatedCompareAtPrice.replace(/[^0-9.]/g, '')) * 100);
        } else {
          // Use regular discount when subscriptions are shown but not selected
          return discount;
        }
      })());
    }
    if ($$self.$$.dirty[0] & /*selectedVariantData*/524288) {
      $: $$invalidate(20, splitName = selectedVariantData?.name?.split("-") || []);
    }
    if ($$self.$$.dirty[0] & /*splitName*/1048576) {
      $: $$invalidate(17, variantName = splitName[0]?.trim());
    }
    if ($$self.$$.dirty[0] & /*splitName*/1048576) {
      $: $$invalidate(16, supplyInterval = splitName[1]?.trim());
    }
    if ($$self.$$.dirty[0] & /*selectedVariantData*/524288) {
      // Variant titles that carry the serving count in brackets — e.g.
      // "3 Pouches (90 Servings)" — only need the bracketed part on screen.
      $: $$invalidate(18, servingCount = selectedVariantData?.name?.match(/\(([^)]+)\)/)?.[1]?.trim());
    }
    if ($$self.$$.dirty[0] & /*supplyTextOverride, servingCount, variantName, supplyInterval*/475136) {
      // Products whose variant name has no "-" (single-variant products) only
      // have the first part — never print an empty/undefined second half.
      $: $$invalidate(7, supplyText = (() => {
        if (supplyTextOverride) return supplyTextOverride;
        if (servingCount) return `${servingCount}.`;
        return [variantName, supplyInterval].filter(Boolean).map(part => `${part}.`).join(' ');
      })());
    }
    if ($$self.$$.dirty[0] & /*calculatedDiscount, calculatedCompareAtPrice, displayPrice, discountBgColor*/36960) {
      // Update data-discount-tag element with calculated discount
      $: {
        const discountTagElement = document.querySelector('[data-discount-tag]');
        if (discountTagElement) {
          if (calculatedDiscount && calculatedCompareAtPrice && calculatedCompareAtPrice != displayPrice) {
            discountTagElement.textContent = `${calculatedDiscount}% off`;

            // Apply background color if provided
            if (discountBgColor) {
              discountTagElement.style.backgroundColor = discountBgColor;
            }
          } else {
            discountTagElement.textContent = '';
          }
        }
      }
    }
  };
  return [wrapperClass, showSupplyText, subscriptionOnly, subscriptionNoteLines, hidePriceDecimals, displayPrice, calculatedCompareAtPrice, supplyText, variantSelectorType, productId, finalDiscountedPrice, showSubscription, discountBgColor, dropdownContent, supplyTextOverride, calculatedDiscount, supplyInterval, variantName, servingCount, selectedVariantData, splitName, discount, subscriptionsEnabled, displayPriceRaw, priceWithoutCurrency, $selectedSellingPlanStore, $selectedVariant];
}
class Variant_description_minimal extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      wrapperClass: 0,
      variantSelectorType: 8,
      productId: 9,
      finalDiscountedPrice: 10,
      showSubscription: 11,
      discountBgColor: 12,
      dropdownContent: 13,
      showSupplyText: 1,
      supplyTextOverride: 14,
      subscriptionOnly: 2,
      subscriptionNoteLines: 3,
      hidePriceDecimals: 4
    }, null, [-1, -1]);
  }
  get wrapperClass() {
    return this.$$.ctx[0];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get variantSelectorType() {
    return this.$$.ctx[8];
  }
  set variantSelectorType(variantSelectorType) {
    this.$$set({
      variantSelectorType
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get productId() {
    return this.$$.ctx[9];
  }
  set productId(productId) {
    this.$$set({
      productId
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get finalDiscountedPrice() {
    return this.$$.ctx[10];
  }
  set finalDiscountedPrice(finalDiscountedPrice) {
    this.$$set({
      finalDiscountedPrice
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get showSubscription() {
    return this.$$.ctx[11];
  }
  set showSubscription(showSubscription) {
    this.$$set({
      showSubscription
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get discountBgColor() {
    return this.$$.ctx[12];
  }
  set discountBgColor(discountBgColor) {
    this.$$set({
      discountBgColor
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get dropdownContent() {
    return this.$$.ctx[13];
  }
  set dropdownContent(dropdownContent) {
    this.$$set({
      dropdownContent
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get showSupplyText() {
    return this.$$.ctx[1];
  }
  set showSupplyText(showSupplyText) {
    this.$$set({
      showSupplyText
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get supplyTextOverride() {
    return this.$$.ctx[14];
  }
  set supplyTextOverride(supplyTextOverride) {
    this.$$set({
      supplyTextOverride
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get subscriptionOnly() {
    return this.$$.ctx[2];
  }
  set subscriptionOnly(subscriptionOnly) {
    this.$$set({
      subscriptionOnly
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get subscriptionNoteLines() {
    return this.$$.ctx[3];
  }
  set subscriptionNoteLines(subscriptionNoteLines) {
    this.$$set({
      subscriptionNoteLines
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get hidePriceDecimals() {
    return this.$$.ctx[4];
  }
  set hidePriceDecimals(hidePriceDecimals) {
    this.$$set({
      hidePriceDecimals
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_description_minimal, {
  "wrapperClass": {},
  "variantSelectorType": {},
  "productId": {},
  "finalDiscountedPrice": {},
  "showSubscription": {},
  "discountBgColor": {},
  "dropdownContent": {},
  "showSupplyText": {
    "type": "Boolean"
  },
  "supplyTextOverride": {},
  "subscriptionOnly": {
    "type": "Boolean"
  },
  "subscriptionNoteLines": {},
  "hidePriceDecimals": {
    "type": "Boolean"
  }
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_description_minimal);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-dropdown-selector.svelte":
/*!*****************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-dropdown-selector.svelte ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* js/components/landing-page-buy-box/variant-dropdown-selector.svelte generated by Svelte v4.2.19 */



function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[11] = list[i];
  return child_ctx;
}

// (41:4) {#if label}
function create_if_block_1(ctx) {
  let div;
  let t;
  let div_class_value;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*label*/ctx[2]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value = `${/*wrapperClass*/ctx[0]}__product-info-heading`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, t);
    },
    p(ctx, dirty) {
      if (dirty & /*label*/4) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t, /*label*/ctx[2]);
      if (dirty & /*wrapperClass*/1 && div_class_value !== (div_class_value = `${/*wrapperClass*/ctx[0]}__product-info-heading`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", div_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}

// (48:60) {#if variant.supply}
function create_if_block(ctx) {
  let t0;
  let t1_value = /*variant*/ctx[11].supply + "";
  let t1;
  let t2;
  return {
    c() {
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("(");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(")");
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t0, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t2, anchor);
    },
    p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t0);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t1);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t2);
      }
    }
  };
}

// (47:10) {#each variantsMap as variant}
function create_each_block(ctx) {
  let option;
  let t_value = /*variant*/ctx[11].variantName + "";
  let t;
  let option_value_value;
  let if_block = /*variant*/ctx[11].supply && create_if_block(ctx);
  return {
    c() {
      option = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("option");
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
      if (if_block) if_block.c();
      option.__value = option_value_value = /*variant*/ctx[11].id;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_input_value)(option, option.__value);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, option, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(option, t);
      if (if_block) if_block.m(option, null);
    },
    p(ctx, dirty) {
      if (/*variant*/ctx[11].supply) if_block.p(ctx, dirty);
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(option);
      }
      if (if_block) if_block.d();
    }
  };
}

// (45:6) {#key $selectedVariant[productId]?.id}
function create_key_block(ctx) {
  let select;
  let select_class_value;
  let select_aria_label_value;
  let mounted;
  let dispose;
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variantsMap*/ctx[5]);
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  return {
    c() {
      select = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("select");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "class", select_class_value = `${/*wrapperClass*/ctx[0]}__product-dropdown`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "aria-label", select_aria_label_value = /*label*/ctx[2] || 'Select product size');
      if (/*selectedVariantId*/ctx[3] === void 0) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_render_callback)(() => /*select_change_handler*/ctx[9].call(select));
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, select, anchor);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(select, null);
        }
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_option)(select, /*selectedVariantId*/ctx[3], true);
      if (!mounted) {
        dispose = [(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(select, "change", /*select_change_handler*/ctx[9]), (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(select, "change", /*change_handler*/ctx[10])];
        mounted = true;
      }
    },
    p(ctx, dirty) {
      if (dirty & /*variantsMap*/32) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variantsMap*/ctx[5]);
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(select, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
      if (dirty & /*wrapperClass*/1 && select_class_value !== (select_class_value = `${/*wrapperClass*/ctx[0]}__product-dropdown`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "class", select_class_value);
      }
      if (dirty & /*label*/4 && select_aria_label_value !== (select_aria_label_value = /*label*/ctx[2] || 'Select product size')) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(select, "aria-label", select_aria_label_value);
      }
      if (dirty & /*selectedVariantId, variantsMap*/40) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_option)(select, /*selectedVariantId*/ctx[3]);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(select);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
      mounted = false;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
    }
  };
}
function create_fragment(ctx) {
  let div1;
  let t;
  let div0;
  let previous_key = /*$selectedVariant*/ctx[4][/*productId*/ctx[1]]?.id;
  let div0_class_value;
  let div1_class_value;
  let if_block = /*label*/ctx[2] && create_if_block_1(ctx);
  let key_block = create_key_block(ctx);
  return {
    c() {
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      if (if_block) if_block.c();
      t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      key_block.c();
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ctx[0]}__select-wrapper`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `
  ${/*wrapperClass*/ctx[0]}__product-info-row
  ${/*wrapperClass*/ctx[0]}__product-more-options
  ${/*wrapperClass*/ctx[0]}__dropdown-selector
   `);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
      if (if_block) if_block.m(div1, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, div0);
      key_block.m(div0, null);
    },
    p(ctx, [dirty]) {
      if (/*label*/ctx[2]) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block_1(ctx);
          if_block.c();
          if_block.m(div1, t);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
      if (dirty & /*$selectedVariant, productId*/18 && (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal)(previous_key, previous_key = /*$selectedVariant*/ctx[4][/*productId*/ctx[1]]?.id)) {
        key_block.d(1);
        key_block = create_key_block(ctx);
        key_block.c();
        key_block.m(div0, null);
      } else {
        key_block.p(ctx, dirty);
      }
      if (dirty & /*wrapperClass*/1 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ctx[0]}__select-wrapper`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (dirty & /*wrapperClass*/1 && div1_class_value !== (div1_class_value = `
  ${/*wrapperClass*/ctx[0]}__product-info-row
  ${/*wrapperClass*/ctx[0]}__product-more-options
  ${/*wrapperClass*/ctx[0]}__dropdown-selector
   `)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
    },
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
      }
      if (if_block) if_block.d();
      key_block.d(detaching);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let $selectedVariant;
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_2__.selectedVariant, $$value => $$invalidate(4, $selectedVariant = $$value));
  let {
    variants
  } = $$props;
  let {
    callback
  } = $$props;
  let {
    wrapperClass
  } = $$props;
  let {
    productId
  } = $$props;
  let {
    label = "Select Size"
  } = $$props;
  const variantsMap = variants.map(item => {
    const {
      name,
      id
    } = item;
    const nameSplit = (name || '').split('-');
    const variantName = nameSplit[0]?.trim() ?? '';
    const supply = nameSplit[1]?.trim() ?? '';
    return {
      id,
      variantName,
      supply
    };
  });

  // Products with no available variants render an empty list, so ignore
  // undefined ids instead of clearing the current selection.
  const handleSelectChange = value => {
    if (value === undefined || value === null) return;
    $$invalidate(3, selectedVariantId = value);
  };
  let selectedVariantId = variants[variants.length - 1]?.id;
  function select_change_handler() {
    selectedVariantId = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.select_value)(this);
    $$invalidate(3, selectedVariantId);
    $$invalidate(5, variantsMap);
  }
  const change_handler = ev => {
    handleSelectChange(ev.target.value);
  };
  $$self.$$set = $$props => {
    if ('variants' in $$props) $$invalidate(7, variants = $$props.variants);
    if ('callback' in $$props) $$invalidate(8, callback = $$props.callback);
    if ('wrapperClass' in $$props) $$invalidate(0, wrapperClass = $$props.wrapperClass);
    if ('productId' in $$props) $$invalidate(1, productId = $$props.productId);
    if ('label' in $$props) $$invalidate(2, label = $$props.label);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*$selectedVariant, productId*/18) {
      $: handleSelectChange($selectedVariant[productId]?.id), $selectedVariant;
    }
    if ($$self.$$.dirty & /*selectedVariantId, callback*/264) {
      $: if (selectedVariantId !== undefined) callback(selectedVariantId);
    }
  };
  return [wrapperClass, productId, label, selectedVariantId, $selectedVariant, variantsMap, handleSelectChange, variants, callback, select_change_handler, change_handler];
}
class Variant_dropdown_selector extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      variants: 7,
      callback: 8,
      wrapperClass: 0,
      productId: 1,
      label: 2
    });
  }
  get variants() {
    return this.$$.ctx[7];
  }
  set variants(variants) {
    this.$$set({
      variants
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get callback() {
    return this.$$.ctx[8];
  }
  set callback(callback) {
    this.$$set({
      callback
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get wrapperClass() {
    return this.$$.ctx[0];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get productId() {
    return this.$$.ctx[1];
  }
  set productId(productId) {
    this.$$set({
      productId
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get label() {
    return this.$$.ctx[2];
  }
  set label(label) {
    this.$$set({
      label
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_dropdown_selector, {
  "variants": {},
  "callback": {},
  "wrapperClass": {},
  "productId": {},
  "label": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_dropdown_selector);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-options-selector.svelte":
/*!****************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-options-selector.svelte ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _variant_single_option_alternate_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./variant-single-option-alternate.svelte */ "./js/components/landing-page-buy-box/variant-single-option-alternate.svelte");
/* js/components/landing-page-buy-box/variant-options-selector.svelte generated by Svelte v4.2.19 */



function get_each_context(ctx, list, i) {
  const child_ctx = ctx.slice();
  child_ctx[5] = list[i];
  return child_ctx;
}

// (19:4) {#each variants as variant}
function create_each_block(ctx) {
  let variantsingleoptionalternate;
  let current;
  variantsingleoptionalternate = new _variant_single_option_alternate_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
    props: {
      variant: /*variant*/ctx[5],
      callback: /*callback*/ctx[1],
      wrapperClass: /*wrapperClass*/ctx[2],
      productId: /*productId*/ctx[3],
      hidePriceDecimals: /*hidePriceDecimals*/ctx[4]
    }
  });
  return {
    c() {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantsingleoptionalternate.$$.fragment);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantsingleoptionalternate, target, anchor);
      current = true;
    },
    p(ctx, dirty) {
      const variantsingleoptionalternate_changes = {};
      if (dirty & /*variants*/1) variantsingleoptionalternate_changes.variant = /*variant*/ctx[5];
      if (dirty & /*callback*/2) variantsingleoptionalternate_changes.callback = /*callback*/ctx[1];
      if (dirty & /*wrapperClass*/4) variantsingleoptionalternate_changes.wrapperClass = /*wrapperClass*/ctx[2];
      if (dirty & /*productId*/8) variantsingleoptionalternate_changes.productId = /*productId*/ctx[3];
      if (dirty & /*hidePriceDecimals*/16) variantsingleoptionalternate_changes.hidePriceDecimals = /*hidePriceDecimals*/ctx[4];
      variantsingleoptionalternate.$set(variantsingleoptionalternate_changes);
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantsingleoptionalternate.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantsingleoptionalternate.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantsingleoptionalternate, detaching);
    }
  };
}
function create_fragment(ctx) {
  let div1;
  let div0;
  let t0;
  let div0_class_value;
  let t1;
  let ul;
  let ul_class_value;
  let div1_class_value;
  let current;
  let each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ctx[0]);
  let each_blocks = [];
  for (let i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }
  const out = i => (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i], 1, 1, () => {
    each_blocks[i] = null;
  });
  return {
    c() {
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Options:");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      ul = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("ul");
      for (let i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ctx[2]}__product-info-heading`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(ul, "class", ul_class_value = `${/*wrapperClass*/ctx[2]}__product-options ${/*wrapperClass*/ctx[2]}__product-options--${/*variants*/ctx[0].length}-variants`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `
${/*wrapperClass*/ctx[2]}__product-info-row
${/*wrapperClass*/ctx[2]}__product-more-options
${/*wrapperClass*/ctx[2]}__option-selector
 `);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, div0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, ul);
      for (let i = 0; i < each_blocks.length; i += 1) {
        if (each_blocks[i]) {
          each_blocks[i].m(ul, null);
        }
      }
      current = true;
    },
    p(ctx, [dirty]) {
      if (!current || dirty & /*wrapperClass*/4 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ctx[2]}__product-info-heading`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (dirty & /*variants, callback, wrapperClass, productId, hidePriceDecimals*/31) {
        each_value = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.ensure_array_like)(/*variants*/ctx[0]);
        let i;
        for (i = 0; i < each_value.length; i += 1) {
          const child_ctx = get_each_context(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block(child_ctx);
            each_blocks[i].c();
            (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i], 1);
            each_blocks[i].m(ul, null);
          }
        }
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
      }
      if (!current || dirty & /*wrapperClass, variants*/5 && ul_class_value !== (ul_class_value = `${/*wrapperClass*/ctx[2]}__product-options ${/*wrapperClass*/ctx[2]}__product-options--${/*variants*/ctx[0].length}-variants`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(ul, "class", ul_class_value);
      }
      if (!current || dirty & /*wrapperClass*/4 && div1_class_value !== (div1_class_value = `
${/*wrapperClass*/ctx[2]}__product-info-row
${/*wrapperClass*/ctx[2]}__product-more-options
${/*wrapperClass*/ctx[2]}__option-selector
 `)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
    },
    i(local) {
      if (current) return;
      for (let i = 0; i < each_value.length; i += 1) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(each_blocks[i]);
      }
      current = true;
    },
    o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (let i = 0; i < each_blocks.length; i += 1) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(each_blocks[i]);
      }
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let {
    variants
  } = $$props;
  let {
    callback
  } = $$props;
  let {
    wrapperClass
  } = $$props;
  let {
    productId
  } = $$props;
  let {
    hidePriceDecimals = false
  } = $$props;
  $$self.$$set = $$props => {
    if ('variants' in $$props) $$invalidate(0, variants = $$props.variants);
    if ('callback' in $$props) $$invalidate(1, callback = $$props.callback);
    if ('wrapperClass' in $$props) $$invalidate(2, wrapperClass = $$props.wrapperClass);
    if ('productId' in $$props) $$invalidate(3, productId = $$props.productId);
    if ('hidePriceDecimals' in $$props) $$invalidate(4, hidePriceDecimals = $$props.hidePriceDecimals);
  };
  return [variants, callback, wrapperClass, productId, hidePriceDecimals];
}
class Variant_options_selector extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      variants: 0,
      callback: 1,
      wrapperClass: 2,
      productId: 3,
      hidePriceDecimals: 4
    });
  }
  get variants() {
    return this.$$.ctx[0];
  }
  set variants(variants) {
    this.$$set({
      variants
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get callback() {
    return this.$$.ctx[1];
  }
  set callback(callback) {
    this.$$set({
      callback
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get wrapperClass() {
    return this.$$.ctx[2];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get productId() {
    return this.$$.ctx[3];
  }
  set productId(productId) {
    this.$$set({
      productId
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get hidePriceDecimals() {
    return this.$$.ctx[4];
  }
  set hidePriceDecimals(hidePriceDecimals) {
    this.$$set({
      hidePriceDecimals
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_options_selector, {
  "variants": {},
  "callback": {},
  "wrapperClass": {},
  "productId": {},
  "hidePriceDecimals": {
    "type": "Boolean"
  }
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_options_selector);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-options.svelte":
/*!*******************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-options.svelte ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var _variant_dropdown_selector_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./variant-dropdown-selector.svelte */ "./js/components/landing-page-buy-box/variant-dropdown-selector.svelte");
/* harmony import */ var _variant_options_selector_svelte__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./variant-options-selector.svelte */ "./js/components/landing-page-buy-box/variant-options-selector.svelte");
/* harmony import */ var _variant_cards_selector_svelte__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./variant-cards-selector.svelte */ "./js/components/landing-page-buy-box/variant-cards-selector.svelte");
/* harmony import */ var _plan_dropdown_selector_svelte__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./plan-dropdown-selector.svelte */ "./js/components/landing-page-buy-box/plan-dropdown-selector.svelte");
/* harmony import */ var _plan_radio_selector_svelte__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./plan-radio-selector.svelte */ "./js/components/landing-page-buy-box/plan-radio-selector.svelte");
/* js/components/landing-page-buy-box/variant-options.svelte generated by Svelte v4.2.19 */








function create_else_block(ctx) {
  let variantdropdownselector;
  let current;
  variantdropdownselector = new _variant_dropdown_selector_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
    props: {
      variants: /*variants*/ctx[0],
      callback: /*onChangeCallBack*/ctx[9],
      wrapperClass: /*wrapperClass*/ctx[1],
      productId: /*productId*/ctx[3],
      label: /*dropdownLabel*/ctx[11]
    }
  });
  return {
    c() {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantdropdownselector.$$.fragment);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantdropdownselector, target, anchor);
      current = true;
    },
    p(ctx, dirty) {
      const variantdropdownselector_changes = {};
      if (dirty & /*variants*/1) variantdropdownselector_changes.variants = /*variants*/ctx[0];
      if (dirty & /*wrapperClass*/2) variantdropdownselector_changes.wrapperClass = /*wrapperClass*/ctx[1];
      if (dirty & /*productId*/8) variantdropdownselector_changes.productId = /*productId*/ctx[3];
      variantdropdownselector.$set(variantdropdownselector_changes);
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantdropdownselector.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantdropdownselector.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantdropdownselector, detaching);
    }
  };
}

// (59:41) 
function create_if_block_4(ctx) {
  let variantcardsselector;
  let current;
  variantcardsselector = new _variant_cards_selector_svelte__WEBPACK_IMPORTED_MODULE_3__["default"]({
    props: {
      variants: /*variants*/ctx[0],
      callback: /*onChangeCallBack*/ctx[9],
      wrapperClass: /*wrapperClass*/ctx[1],
      productId: /*productId*/ctx[3],
      settings: /*settings*/ctx[2]
    }
  });
  return {
    c() {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantcardsselector.$$.fragment);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantcardsselector, target, anchor);
      current = true;
    },
    p(ctx, dirty) {
      const variantcardsselector_changes = {};
      if (dirty & /*variants*/1) variantcardsselector_changes.variants = /*variants*/ctx[0];
      if (dirty & /*wrapperClass*/2) variantcardsselector_changes.wrapperClass = /*wrapperClass*/ctx[1];
      if (dirty & /*productId*/8) variantcardsselector_changes.productId = /*productId*/ctx[3];
      if (dirty & /*settings*/4) variantcardsselector_changes.settings = /*settings*/ctx[2];
      variantcardsselector.$set(variantcardsselector_changes);
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantcardsselector.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantcardsselector.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantcardsselector, detaching);
    }
  };
}

// (57:43) 
function create_if_block_3(ctx) {
  let variantoptionsselector;
  let current;
  variantoptionsselector = new _variant_options_selector_svelte__WEBPACK_IMPORTED_MODULE_4__["default"]({
    props: {
      variants: /*variants*/ctx[0],
      callback: /*onChangeCallBack*/ctx[9],
      wrapperClass: /*wrapperClass*/ctx[1],
      productId: /*productId*/ctx[3],
      hidePriceDecimals: /*settings*/ctx[2]?.hidePriceDecimals
    }
  });
  return {
    c() {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(variantoptionsselector.$$.fragment);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(variantoptionsselector, target, anchor);
      current = true;
    },
    p(ctx, dirty) {
      const variantoptionsselector_changes = {};
      if (dirty & /*variants*/1) variantoptionsselector_changes.variants = /*variants*/ctx[0];
      if (dirty & /*wrapperClass*/2) variantoptionsselector_changes.wrapperClass = /*wrapperClass*/ctx[1];
      if (dirty & /*productId*/8) variantoptionsselector_changes.productId = /*productId*/ctx[3];
      if (dirty & /*settings*/4) variantoptionsselector_changes.hidePriceDecimals = /*settings*/ctx[2]?.hidePriceDecimals;
      variantoptionsselector.$set(variantoptionsselector_changes);
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(variantoptionsselector.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(variantoptionsselector.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(variantoptionsselector, detaching);
    }
  };
}

// (47:20) 
function create_if_block_2(ctx) {
  let plandropdownselector;
  let current;
  plandropdownselector = new _plan_dropdown_selector_svelte__WEBPACK_IMPORTED_MODULE_5__["default"]({
    props: {
      sellingPlanGroups: /*sellingPlanGroups*/ctx[4],
      wrapperClass: /*wrapperClass*/ctx[1],
      label: /*dropdownLabel*/ctx[11],
      oneTimeLabel: /*oneTimeLabel*/ctx[12],
      showOneTime: /*showOneTimeOption*/ctx[13],
      defaultPlan: /*defaultPlan*/ctx[14],
      placeholderLabel: /*variantSelectorType*/ctx[10] == 'dropdown' ? /*placeholderLabel*/ctx[15] : ''
    }
  });
  return {
    c() {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(plandropdownselector.$$.fragment);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(plandropdownselector, target, anchor);
      current = true;
    },
    p(ctx, dirty) {
      const plandropdownselector_changes = {};
      if (dirty & /*sellingPlanGroups*/16) plandropdownselector_changes.sellingPlanGroups = /*sellingPlanGroups*/ctx[4];
      if (dirty & /*wrapperClass*/2) plandropdownselector_changes.wrapperClass = /*wrapperClass*/ctx[1];
      plandropdownselector.$set(plandropdownselector_changes);
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(plandropdownselector.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(plandropdownselector.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(plandropdownselector, detaching);
    }
  };
}

// (34:56) 
function create_if_block_1(ctx) {
  let planradioselector;
  let current;
  planradioselector = new _plan_radio_selector_svelte__WEBPACK_IMPORTED_MODULE_6__["default"]({
    props: {
      sellingPlanGroups: /*sellingPlanGroups*/ctx[4],
      wrapperClass: /*wrapperClass*/ctx[1],
      label: /*dropdownLabel*/ctx[11],
      oneTimeLabel: /*oneTimeLabel*/ctx[12],
      showOneTime: /*showOneTimeOption*/ctx[13],
      defaultPlan: /*defaultPlan*/ctx[14],
      subscribeLabel: /*subscribeLabel*/ctx[16],
      subscribeNote: /*subscribeNote*/ctx[17],
      orderDiscount: /*orderDiscount*/ctx[5],
      recurringDiscount: /*recurringDiscount*/ctx[6]
    }
  });
  return {
    c() {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(planradioselector.$$.fragment);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(planradioselector, target, anchor);
      current = true;
    },
    p(ctx, dirty) {
      const planradioselector_changes = {};
      if (dirty & /*sellingPlanGroups*/16) planradioselector_changes.sellingPlanGroups = /*sellingPlanGroups*/ctx[4];
      if (dirty & /*wrapperClass*/2) planradioselector_changes.wrapperClass = /*wrapperClass*/ctx[1];
      if (dirty & /*orderDiscount*/32) planradioselector_changes.orderDiscount = /*orderDiscount*/ctx[5];
      if (dirty & /*recurringDiscount*/64) planradioselector_changes.recurringDiscount = /*recurringDiscount*/ctx[6];
      planradioselector.$set(planradioselector_changes);
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(planradioselector.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(planradioselector.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(planradioselector, detaching);
    }
  };
}

// (32:0) {#if subscriptionOnly}
function create_if_block(ctx) {
  return {
    c: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    m: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop
  };
}
function create_fragment(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block, create_if_block_1, create_if_block_2, create_if_block_3, create_if_block_4, create_else_block];
  const if_blocks = [];
  function select_block_type(ctx, dirty) {
    if (/*subscriptionOnly*/ctx[7]) return 0;
    if (/*showPlans*/ctx[8] && /*variantSelectorType*/ctx[10] == 'default') return 1;
    if (/*showPlans*/ctx[8]) return 2;
    if (/*variantSelectorType*/ctx[10] == "default") return 3;
    if (/*variantSelectorType*/ctx[10] == "cards") return 4;
    return 5;
  }
  current_block_type_index = select_block_type(ctx, -1);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c() {
      if_block.c();
      if_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
    },
    m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx, [dirty]) {
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx, dirty);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_blocks[previous_block_index], 1, 1, () => {
          if_blocks[previous_block_index] = null;
        });
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        } else {
          if_block.p(ctx, dirty);
        }
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_block);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(if_block_anchor);
      }
      if_blocks[current_block_type_index].d(detaching);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let showPlans;
  let {
    variants
  } = $$props;
  let {
    wrapperClass
  } = $$props;
  let {
    settings
  } = $$props;
  let {
    productId
  } = $$props;
  let {
    sellingPlanGroups = []
  } = $$props;
  let {
    orderDiscount = ''
  } = $$props;
  let {
    recurringDiscount = ''
  } = $$props;
  let {
    subscriptionOnly = false
  } = $$props;
  const onChangeCallBack = id => {
    const variantObj = variants.find(variant => variant.id == id);
    if (variantObj) {
      (0,_buy_box_store__WEBPACK_IMPORTED_MODULE_7__.updateSelectedVariant)({
        variantObj,
        productId
      });
    }
  };
  const {
    variantSelectorType,
    dropdownContent,
    dropdownLabel,
    oneTimeLabel,
    showOneTimeOption,
    defaultPlan,
    placeholderLabel,
    subscribeLabel,
    subscribeNote
  } = settings || {};
  $$self.$$set = $$props => {
    if ('variants' in $$props) $$invalidate(0, variants = $$props.variants);
    if ('wrapperClass' in $$props) $$invalidate(1, wrapperClass = $$props.wrapperClass);
    if ('settings' in $$props) $$invalidate(2, settings = $$props.settings);
    if ('productId' in $$props) $$invalidate(3, productId = $$props.productId);
    if ('sellingPlanGroups' in $$props) $$invalidate(4, sellingPlanGroups = $$props.sellingPlanGroups);
    if ('orderDiscount' in $$props) $$invalidate(5, orderDiscount = $$props.orderDiscount);
    if ('recurringDiscount' in $$props) $$invalidate(6, recurringDiscount = $$props.recurringDiscount);
    if ('subscriptionOnly' in $$props) $$invalidate(7, subscriptionOnly = $$props.subscriptionOnly);
  };
  $$self.$$.update = () => {
    if ($$self.$$.dirty & /*sellingPlanGroups*/16) {
      // Products with a single variant can use the same control to pick a
      // subscription plan instead of a size.
      $: $$invalidate(8, showPlans = dropdownContent === 'selling_plans' && (sellingPlanGroups || []).length > 0);
    }
  };
  return [variants, wrapperClass, settings, productId, sellingPlanGroups, orderDiscount, recurringDiscount, subscriptionOnly, showPlans, onChangeCallBack, variantSelectorType, dropdownLabel, oneTimeLabel, showOneTimeOption, defaultPlan, placeholderLabel, subscribeLabel, subscribeNote];
}
class Variant_options extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      variants: 0,
      wrapperClass: 1,
      settings: 2,
      productId: 3,
      sellingPlanGroups: 4,
      orderDiscount: 5,
      recurringDiscount: 6,
      subscriptionOnly: 7
    });
  }
  get variants() {
    return this.$$.ctx[0];
  }
  set variants(variants) {
    this.$$set({
      variants
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get wrapperClass() {
    return this.$$.ctx[1];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get settings() {
    return this.$$.ctx[2];
  }
  set settings(settings) {
    this.$$set({
      settings
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get productId() {
    return this.$$.ctx[3];
  }
  set productId(productId) {
    this.$$set({
      productId
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get sellingPlanGroups() {
    return this.$$.ctx[4];
  }
  set sellingPlanGroups(sellingPlanGroups) {
    this.$$set({
      sellingPlanGroups
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get orderDiscount() {
    return this.$$.ctx[5];
  }
  set orderDiscount(orderDiscount) {
    this.$$set({
      orderDiscount
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get recurringDiscount() {
    return this.$$.ctx[6];
  }
  set recurringDiscount(recurringDiscount) {
    this.$$set({
      recurringDiscount
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get subscriptionOnly() {
    return this.$$.ctx[7];
  }
  set subscriptionOnly(subscriptionOnly) {
    this.$$set({
      subscriptionOnly
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_options, {
  "variants": {},
  "wrapperClass": {},
  "settings": {},
  "productId": {},
  "sellingPlanGroups": {},
  "orderDiscount": {},
  "recurringDiscount": {},
  "subscriptionOnly": {
    "type": "Boolean"
  }
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_options);

/***/ }),

/***/ "./js/components/landing-page-buy-box/variant-single-option-alternate.svelte":
/*!***********************************************************************************!*\
  !*** ./js/components/landing-page-buy-box/variant-single-option-alternate.svelte ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* harmony import */ var JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/responsive-image.svelte */ "./js/components/responsive-image.svelte");
/* harmony import */ var _buy_box_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./buy-box-store */ "./js/components/landing-page-buy-box/buy-box-store.js");
/* harmony import */ var _price_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./price-format */ "./js/components/landing-page-buy-box/price-format.js");
/* js/components/landing-page-buy-box/variant-single-option-alternate.svelte generated by Svelte v4.2.19 */





function create_else_block(ctx) {
  let div0;
  let t0;
  let div0_class_value;
  let t1;
  let div1;
  let t2;
  let div1_class_value;
  return {
    c() {
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*variantName*/ctx[9]);
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*variantNameMobile*/ctx[8]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ctx[3]}__product-option-name landing-page-buy-box__product-option-info--desktop`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ctx[3]}__product-option-name landing-page-buy-box__product-option-info--mobile`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div0, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t2);
    },
    p(ctx, dirty) {
      if (dirty & /*wrapperClass*/8 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ctx[3]}__product-option-name landing-page-buy-box__product-option-info--desktop`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (dirty & /*wrapperClass*/8 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ctx[3]}__product-option-name landing-page-buy-box__product-option-info--mobile`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div0);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t1);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
      }
    }
  };
}

// (39:3) {#if flag}
function create_if_block(ctx) {
  let div0;
  let t0;
  let div0_class_value;
  let t1;
  let div1;
  let t2;
  let t3;
  let t4;
  let t5;
  let div1_class_value;
  return {
    c() {
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*customVariantName*/ctx[10]);
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*customVariantName*/ctx[10]);
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" (");
      t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*customVariantNameMobile*/ctx[11]);
      t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(")");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ctx[3]}__product-option-name landing-page-buy-box__product-option-info--desktop`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ctx[3]}__product-option-name landing-page-buy-box__product-option-info--mobile`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div0, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div0, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, t1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div1, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t3);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t4);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div1, t5);
    },
    p(ctx, dirty) {
      if (dirty & /*wrapperClass*/8 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ctx[3]}__product-option-name landing-page-buy-box__product-option-info--desktop`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (dirty & /*wrapperClass*/8 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ctx[3]}__product-option-name landing-page-buy-box__product-option-info--mobile`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div0);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(t1);
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div1);
      }
    }
  };
}
function create_fragment(ctx) {
  let div5;
  let div4;
  let div0;
  let responsiveimage;
  let div0_class_value;
  let t0;
  let div1;
  let div1_class_value;
  let t1;
  let div3;
  let t2;
  let div2;
  let t3_value = (0,_price_format__WEBPACK_IMPORTED_MODULE_2__.formatMoneyString)(/*price*/ctx[7], /*hidePriceDecimals*/ctx[0]) + "";
  let t3;
  let div2_class_value;
  let div3_class_value;
  let div4_class_value;
  let div5_class_value;
  let current;
  let mounted;
  let dispose;
  responsiveimage = new JsComponents_responsive_image_svelte__WEBPACK_IMPORTED_MODULE_3__["default"]({
    props: {
      image: /*image*/ctx[5],
      image_aspect_ratio: "1",
      objectFit: "cover",
      maxHeight: "78"
    }
  });
  function select_block_type(ctx, dirty) {
    if (flag) return create_if_block;
    return create_else_block;
  }
  let current_block_type = select_block_type(ctx, -1);
  let if_block = current_block_type(ctx);
  return {
    c() {
      div5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(responsiveimage.$$.fragment);
      t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      if_block.c();
      t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
      div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t3_value);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value = `${/*wrapperClass*/ctx[3]}__product-option-image`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value = `${/*wrapperClass*/ctx[3]}__divider`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value = `${/*wrapperClass*/ctx[3]}__product-option-price`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value = `${/*wrapperClass*/ctx[3]}__product-option-info`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div4, "class", div4_class_value = `${/*wrapperClass*/ctx[3]}__product-option-link`);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div4, "data-variant-slide-id", "4");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div5, "class", div5_class_value = `${/*wrapperClass*/ctx[3]}__product-option ${/*$selectedVariant*/ctx[4][/*productId*/ctx[2]]?.id == /*id*/ctx[6] ? "selected" : ""}`);
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div5, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div5, div4);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, div0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(responsiveimage, div0, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, t0);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, div1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, t1);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div4, div3);
      if_block.m(div3, null);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, t2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div3, div2);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div2, t3);
      current = true;
      if (!mounted) {
        dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen)(div5, "click", /*click_handler*/ctx[13]);
        mounted = true;
      }
    },
    p(ctx, [dirty]) {
      if (!current || dirty & /*wrapperClass*/8 && div0_class_value !== (div0_class_value = `${/*wrapperClass*/ctx[3]}__product-option-image`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div0, "class", div0_class_value);
      }
      if (!current || dirty & /*wrapperClass*/8 && div1_class_value !== (div1_class_value = `${/*wrapperClass*/ctx[3]}__divider`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div1, "class", div1_class_value);
      }
      if_block.p(ctx, dirty);
      if ((!current || dirty & /*hidePriceDecimals*/1) && t3_value !== (t3_value = (0,_price_format__WEBPACK_IMPORTED_MODULE_2__.formatMoneyString)(/*price*/ctx[7], /*hidePriceDecimals*/ctx[0]) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data)(t3, t3_value);
      if (!current || dirty & /*wrapperClass*/8 && div2_class_value !== (div2_class_value = `${/*wrapperClass*/ctx[3]}__product-option-price`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div2, "class", div2_class_value);
      }
      if (!current || dirty & /*wrapperClass*/8 && div3_class_value !== (div3_class_value = `${/*wrapperClass*/ctx[3]}__product-option-info`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div3, "class", div3_class_value);
      }
      if (!current || dirty & /*wrapperClass*/8 && div4_class_value !== (div4_class_value = `${/*wrapperClass*/ctx[3]}__product-option-link`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div4, "class", div4_class_value);
      }
      if (!current || dirty & /*wrapperClass, $selectedVariant, productId*/28 && div5_class_value !== (div5_class_value = `${/*wrapperClass*/ctx[3]}__product-option ${/*$selectedVariant*/ctx[4][/*productId*/ctx[2]]?.id == /*id*/ctx[6] ? "selected" : ""}`)) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div5, "class", div5_class_value);
      }
    },
    i(local) {
      if (current) return;
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(responsiveimage.$$.fragment, local);
      current = true;
    },
    o(local) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(responsiveimage.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div5);
      }
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(responsiveimage);
      if_block.d();
      mounted = false;
      dispose();
    }
  };
}
const flag = true; //set true, to display custom variant name(metafield)

function instance($$self, $$props, $$invalidate) {
  let $selectedVariant;
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _buy_box_store__WEBPACK_IMPORTED_MODULE_4__.selectedVariant, $$value => $$invalidate(4, $selectedVariant = $$value));
  let {
    variant
  } = $$props;
  let {
    hidePriceDecimals = false
  } = $$props;
  let {
    callback
  } = $$props;
  let {
    productId
  } = $$props;
  let {
    wrapperClass
  } = $$props;
  const {
    image,
    name,
    id,
    price,
    customVariantText
  } = variant;
  const splitName = name.split("-");
  const variantNameMobile = name.replace(/-\s*(.*)/, "($1)");
  const variantName = splitName[0];
  const customVariantName = customVariantText;
  const customVariantNameMobile = splitName[1];
  const click_handler = () => {
    callback(id);
  };
  $$self.$$set = $$props => {
    if ('variant' in $$props) $$invalidate(12, variant = $$props.variant);
    if ('hidePriceDecimals' in $$props) $$invalidate(0, hidePriceDecimals = $$props.hidePriceDecimals);
    if ('callback' in $$props) $$invalidate(1, callback = $$props.callback);
    if ('productId' in $$props) $$invalidate(2, productId = $$props.productId);
    if ('wrapperClass' in $$props) $$invalidate(3, wrapperClass = $$props.wrapperClass);
  };
  return [hidePriceDecimals, callback, productId, wrapperClass, $selectedVariant, image, id, price, variantNameMobile, variantName, customVariantName, customVariantNameMobile, variant, click_handler];
}
class Variant_single_option_alternate extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      variant: 12,
      hidePriceDecimals: 0,
      callback: 1,
      productId: 2,
      wrapperClass: 3
    });
  }
  get variant() {
    return this.$$.ctx[12];
  }
  set variant(variant) {
    this.$$set({
      variant
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get hidePriceDecimals() {
    return this.$$.ctx[0];
  }
  set hidePriceDecimals(hidePriceDecimals) {
    this.$$set({
      hidePriceDecimals
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get callback() {
    return this.$$.ctx[1];
  }
  set callback(callback) {
    this.$$set({
      callback
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get productId() {
    return this.$$.ctx[2];
  }
  set productId(productId) {
    this.$$set({
      productId
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get wrapperClass() {
    return this.$$.ctx[3];
  }
  set wrapperClass(wrapperClass) {
    this.$$set({
      wrapperClass
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Variant_single_option_alternate, {
  "variant": {},
  "hidePriceDecimals": {
    "type": "Boolean"
  },
  "callback": {},
  "productId": {},
  "wrapperClass": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Variant_single_option_alternate);

/***/ }),

/***/ "./js/components/responsive-image.svelte":
/*!***********************************************!*\
  !*** ./js/components/responsive-image.svelte ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* js/components/responsive-image.svelte generated by Svelte v4.2.19 */


function add_css(target) {
  (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_styles)(target, "svelte-vrirn3", ".responsive-image__wrapper.svelte-vrirn3:before{content:'';width:100%;display:block;padding-top:var(--padding-top)}.responsive-image__wrapper.svelte-vrirn3{max-width:var(--max-width);height:100%;position:relative;max-height:var(--max-height);height:auto;min-height:var(--min-height)}.responsive-image__image.svelte-vrirn3{position:absolute;top:0;height:100%;left:0;width:100%}");
}
function create_fragment(ctx) {
  let div;
  let img;
  let img_id_value;
  let img_src_value;
  let img_srcset_value;
  let img_style_value;
  let div_id_value;
  let div_style_value;
  return {
    c() {
      div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
      img = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("img");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "id", img_id_value = "Image-" + /*image_id*/ctx[2] + "-" + /*generated_image_id*/ctx[1]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "class", "responsive-image__image svelte-vrirn3");
      if (!(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.src_url_equal)(img.src, img_src_value = /*srcUrl*/ctx[4])) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "src", img_src_value);
      if (!(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.srcset_url_equal)(img, img_srcset_value = /*imageSrcSet*/ctx[3])) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "srcset", img_srcset_value);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "data-aspectratio", /*image_aspect_ratio*/ctx[0]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "tabindex", "-1");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "style", img_style_value = /*getImageStyle*/ctx[6]());
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "loading", "lazy");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "id", div_id_value = "ImageWrapper-" + /*image_id*/ctx[2] + "-" + /*generated_image_id*/ctx[1]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "data-image-id", /*image_id*/ctx[2]);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "responsive-image__wrapper svelte-vrirn3");
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "style", div_style_value = /*getWrapperStyles*/ctx[5]());
    },
    m(target, anchor) {
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
      (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append)(div, img);
    },
    p(ctx, [dirty]) {
      if (dirty & /*image_aspect_ratio*/1) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(img, "data-aspectratio", /*image_aspect_ratio*/ctx[0]);
      }
    },
    i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
    d(detaching) {
      if (detaching) {
        (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
      }
    }
  };
}
let min = 100;
let max = 10000;
function instance($$self, $$props, $$invalidate) {
  let {
    image_aspect_ratio
  } = $$props;
  let {
    image
  } = $$props;
  let {
    objectFit
  } = $$props;
  let {
    minHeight
  } = $$props;
  let {
    maxHeight
  } = $$props;
  let diff = max - min;
  let generated_image_id = Date.now() / diff + min;
  let displayImage = image;
  if (!displayImage) {
    displayImage = {
      width: 1920,
      height: 1080,
      id: Date.now(),
      src: 'https://cdn.shopify.com/s/files/1/0422/2255/1191/files/placeholderImage.webp?v=1692958737'
    };
  }
  let image_id = displayImage.id;
  let max_height_image = displayImage.height;
  let max_width_image = displayImage.width;
  const IMAGE_WIDTHS = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024];
  const getImageWidths = nativeWidth => {
    const imageWidths = [];
    for (let i = 0; i < IMAGE_WIDTHS.length; i++) {
      const width = IMAGE_WIDTHS[i];
      if (nativeWidth > width) {
        imageWidths.push(width);
      } else {
        imageWidths.push(nativeWidth);
        break;
      }
    }
    return imageWidths;
  };
  const imageSizes = getImageWidths(displayImage.width);
  const imageSrcSet = imageSizes.map(width => {
    return `${displayImage.src}&width=${width} ${width}w`;
  }).join(",");
  const max_width_image_float = max_width_image * 1.0;
  let srcUrl = `${displayImage.src}&width=10`;
  (aspectRatio => {
    if (aspectRatio <= 1) {
      max_height_image = image_height;
      max_width_image = max_height_image * image_aspect_ratio;
    } else {
      max_height_image = max_width_image / image_aspect_ratio;
    }
  })();
  const getWrapperStyles = () => {
    return `
    --padding-top: ${max_height_image / max_width_image_float * 100}%;
    --max-height: ${maxHeight || max_height_image}px;
    --max-width: ${max_width_image}px;
    --min-height: ${minHeight}px;
    `;
  };
  const getImageStyle = () => {
    return `
    max-width: ${max_width_image}px;
    max-height: ${max_height_image}px;
    object-fit: ${objectFit ? objectFit : 'contain'};`;
  };
  $$self.$$set = $$props => {
    if ('image_aspect_ratio' in $$props) $$invalidate(0, image_aspect_ratio = $$props.image_aspect_ratio);
    if ('image' in $$props) $$invalidate(7, image = $$props.image);
    if ('objectFit' in $$props) $$invalidate(8, objectFit = $$props.objectFit);
    if ('minHeight' in $$props) $$invalidate(9, minHeight = $$props.minHeight);
    if ('maxHeight' in $$props) $$invalidate(10, maxHeight = $$props.maxHeight);
  };
  return [image_aspect_ratio, generated_image_id, image_id, imageSrcSet, srcUrl, getWrapperStyles, getImageStyle, image, objectFit, minHeight, maxHeight];
}
class Responsive_image extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
  constructor(options) {
    super();
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {
      image_aspect_ratio: 0,
      image: 7,
      objectFit: 8,
      minHeight: 9,
      maxHeight: 10
    }, add_css);
  }
  get image_aspect_ratio() {
    return this.$$.ctx[0];
  }
  set image_aspect_ratio(image_aspect_ratio) {
    this.$$set({
      image_aspect_ratio
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get image() {
    return this.$$.ctx[7];
  }
  set image(image) {
    this.$$set({
      image
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get objectFit() {
    return this.$$.ctx[8];
  }
  set objectFit(objectFit) {
    this.$$set({
      objectFit
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get minHeight() {
    return this.$$.ctx[9];
  }
  set minHeight(minHeight) {
    this.$$set({
      minHeight
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
  get maxHeight() {
    return this.$$.ctx[10];
  }
  set maxHeight(maxHeight) {
    this.$$set({
      maxHeight
    });
    (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.flush)();
  }
}
(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Responsive_image, {
  "image_aspect_ratio": {},
  "image": {},
  "objectFit": {},
  "minHeight": {},
  "maxHeight": {}
}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Responsive_image);

/***/ }),

/***/ "./js/components/scroll-on-click.js":
/*!******************************************!*\
  !*** ./js/components/scroll-on-click.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   scrollOnClick: () => (/* binding */ scrollOnClick)
/* harmony export */ });
/** Do not attach scroll-to-buy-box on the actual buy box button container (would scroll instead of checkout). */
const isBuyBoxButtonContainer = el => el.classList.contains('landing-page-buy-box__product-buy-button');
const scrollOnClick = (selector, target, offset = 0) => {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;
  elements.forEach(item => {
    if (isBuyBoxButtonContainer(item)) return;
    if (item.dataset.scrollListenerAttached === 'true') return;
    item.dataset.scrollListenerAttached = 'true';
    item.addEventListener('click', ev => {
      if (ev.target.closest('.landing-page-buy-box__product-buy-button')) return;
      ev.preventDefault();
      const targetElement = document.querySelector(target);
      if (!targetElement) return;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });
};

/***/ }),

/***/ "./js/components/svelte-wrapper.js":
/*!*****************************************!*\
  !*** ./js/components/svelte-wrapper.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  const appContainer = document.querySelectorAll(container);
  return [...appContainer].map(appTarget => {
    const initialized = appTarget.dataset.initialized || false;
    let props = {};
    if (appTarget && !initialized) {
      try {
        if (propsEl) {
          props = json_6__WEBPACK_IMPORTED_MODULE_0___default().parse(appTarget.querySelector(propsEl)?.innerHTML) || {}; //get json from the script id
        }
        //inject component into container
        const instance = new Component({
          target: appTarget,
          props: {
            shopifyData: props?.data //pass the prop on data prop as default
          }
        });
        appTarget.dataset.initialized = true;
        return instance;
      } catch (err) {
        console.error('[svelte-wrapper] Failed to mount "' + container + '":', err);
        appTarget.dataset.initialized = true; // hide skeleton even on error
      }
    }
  });
});

/***/ })

}]);